
import React, { useState, useEffect, useRef } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chart } from 'primereact/chart';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Menu } from 'primereact/menu';
import { BlockUI } from 'primereact/blockui';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FilterMatchMode } from 'primereact/api';
import { InputNumber } from 'primereact/inputnumber';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { loadGoogleMaps, removeGoogleMaps } from "../GoogleMaps/GoogleMaps";
import { GMap } from 'primereact/gmap';
import { Toast } from 'primereact/toast';
import { LogisticaService } from '../../services/Logistica/LogisticaService';
import { UbicacionesService } from '../../services/Ubicaciones/UbicacionesService';
import { ubicacionesDeViaje } from '../../services/Ubicaciones/ubicacionesDeViaje';
import { anularViaje, reactivarViaje, cambiarDestino, logViaje, logBooking, guardarAtaBnp, reprocesarViaje, reprocesoEstado, recorridoViaje } from '../../services/Logistica/DoleService';
import { ConfiguracionService } from '../../services/Configuracion/ConfiguracionService';
import '../Logistica/logistica.css';
import flagIcon from '../../assets/goal.png';
import { InputText } from 'primereact/inputtext';
import { SelectButton } from 'primereact/selectbutton';
import { aplicarFiltrosColumna, tramosPorEtapa, COLOR_ETAPA, COLOR_LLENO } from './logisticaTramos';
import * as XLSX from 'xlsx';
import ControlTramos from './ControlTramos';



const Logistica = () => {

    const dt = useRef(null);
    const google = window.google;
    var map;
    const [dates, setDates] = useState(null);
    const [viajes, setViajes] = useState([]);
    // Filas sombreadas por el usuario (checkbox) para guiarse a lo largo de la matriz.
    const [filasSel, setFilasSel] = useState([]);
    const [markerTitle, setMarkerTitle] = useState("");
    const toast = useRef(null);
    const [displayMapa, setDisplayMapa] = useState(false);
    const [googleMapsReady, setGoogleMapsReady] = useState(false);
    const [overlays, setOverlays] = useState(null);
    // ---- Visor de recorrido del viaje (trayectoria + destino + radio de llegada) ----
    const [displayRecorrido, setDisplayRecorrido] = useState(false);
    const [recorridoOverlays, setRecorridoOverlays] = useState(null);
    const [recorridoOptions, setRecorridoOptions] = useState({ center: { lat: -2.20584, lng: -79.90795 }, zoom: 10 });
    const [recorridoInfo, setRecorridoInfo] = useState(null); // { booking, destinoNombre, totalPuntos, llego }
    const recorridoBoundsRef = useRef([]);                    // puntos para fitBounds al abrir
    const [blocked, setBlocked] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const [tipoViaje, setTipoViaje] = useState(null);
    const [latitud, setLatitud] = useState("");
    const [longitud, setLongitud] = useState("");

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');


    const mensajeNoCoordenadas = () => {
        toast.current.show({ severity: 'warn', summary: 'Warning', detail: "No Hay Coordenadas", time: 3000 });
    }

    const mensajeNoCoordenadasParaActualizar = () => {
        toast.current.show({ severity: 'warn', summary: 'Warning', detail: "No hay Coordenadas de Viaje para Actualizar", time: 3000 });
    }

    let _options = {
        center:
        {
            lat: -2.2058400,
            lng: -79.9079500
        },
        zoom: 12
    };

    const [tablaInformativa, setTablaInformativa] = useState([]);
    const [options, setOptions] = useState(_options);
    const [chartData, setChartData] = useState({});
    const [lightOptions] = useState({
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }

            },
            datalabels: {
                display: true,
                color: "white",
                align: "center",
                anchor: "center",
                font: { size: "25" }
            }
        }
    });
    const [basicData, setBasicData] = useState({});
    const [semanalBasicData, setSemanalBasicData] = useState({});
    const [diaData, setDiaData] = useState({});
    const [anio, setAnio] = useState();
    const [semana, setSemana] = useState("");
    const [_semana, _setSemana] = useState("");
    const [booking, setBooking] = useState("");
    const [mes, setMes] = useState(null);
    const [dia, setDia] = useState(null);
    const meses = [
        { name: 'Enero', value: "01" },
        { name: 'Febrero', value: "02" },
        { name: 'Marzo', value: "03" },
        { name: 'Abril', value: "04" },
        { name: 'Mayo', value: "05" },
        { name: 'Junio', value: "06" },
        { name: 'Julio', value: "07" },
        { name: 'Agosto', value: "08" },
        { name: 'Septiembre', value: "09" },
        { name: 'Octubre', value: "10" },
        { name: 'Noviembre', value: "11" },
        { name: 'Diciembre', value: "12" }
    ];
    const dias = [
        { name: 'Lunes', value: "1" },
        { name: 'Martes', value: "2" },
        { name: 'Miercoles', value: "3" },
        { name: 'Jueves', value: "4" },
        { name: 'Viernes', value: "5" },
        { name: 'Sabado', value: "6" },
        { name: 'Domingo', value: "0" },
        { name: 'Todos', value: "-1" }
    ];
    const onChangeSemana = (value) => {
        if (value == undefined) {
            _setSemana(-1)
        } else {
            _setSemana(value)
        }
    }
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            },
            datalabels: {
                display: true,
                color: "white",
                align: "center",
                anchor: "center",
                font: { size: "25" }
            }

        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        },

    };
    const optionsDia = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
            legend: {
                labels: {
                    color: textColor
                }
            },
            datalabels: {
                display: true,
                color: "blue",
                align: "top",
                anchor: "center",
                font: { size: "25" }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder
                }
            },
            y: {
                beginAtZero: true,
                ticks: {
                    beginAtZero: true,
                    callback: function (value) { if (Number.isInteger(value)) { return value; } },
                    stepSize: 1,
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder
                }
            }
        }
    };
    let horizontalOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            },
            datalabels: {
                display: true,
                color: "white",
                align: "center",
                anchor: "center",
                font: { size: "25" }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        bookingCodigo: { value: null, matchMode: FilterMatchMode.CONTAINS },
        'chofer': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'empresaTransporte': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'ruta': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'estadoLogistico': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'estadoPosicionamiento': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'motivoCierre': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'motivoInicio': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'contenedor': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'destinoZona': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'destinoCodigoPlantaEmpacadora': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'destinoSector': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'bookingUsuarioCarga': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'tipoViaje': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'vehiculoPlaca': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'vehiculoChasis': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'distanciaKm': { value: null, matchMode: FilterMatchMode.CONTAINS },
        // Estos 3 estaban marcados como filtrables en la grilla pero sin entrada aca,
        // por eso su input no aceptaba texto (no habia meta que actualizar).
        'categoriaContenedor': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'barcoViaje': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'prioridadVacio': { value: null, matchMode: FilterMatchMode.CONTAINS },
        // DOLE tramos a puerto
        'puertoCarga': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'tipoChasis': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'tk': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'trasladoDirecto': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'estadoPuerto': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'alertasPuerto': { value: null, matchMode: FilterMatchMode.CONTAINS },



    });

    const [listaTipoViaje, setListaTipoViaje] = useState(null);

    // ---- Acciones DOLE sobre el viaje (RF-A1 / RF-A5) y log (RF-LOG) ----
    const [accionVisible, setAccionVisible] = useState(false);
    const [accionTipo, setAccionTipo] = useState(null);      // 'anular' | 'reactivar' | 'destino'
    const [accionViaje, setAccionViaje] = useState(null);
    const [accionMotivo, setAccionMotivo] = useState('');
    const [accionDestino, setAccionDestino] = useState('');
    const [accionReactivarBooking, setAccionReactivarBooking] = useState(false);
    const [logVisible, setLogVisible] = useState(false);
    const [logFilas, setLogFilas] = useState([]);

    // ---- RF-A10 Reproceso on-demand (batch con estado) ----
    const ETAPAS_REPRO = [
        { label: 'Cerrar viaje (fecha real de llegada)', value: 'cerrar' },
        { label: 'Tramo Lleno / Vacío (patio seco)', value: 'patio_seco' },
        { label: 'Fechas de candado', value: 'candado' },
        { label: 'ETA / ATA (R10, BNP)', value: 'eta_ata' },
        { label: 'Estado de Posicionamiento', value: 'estado' },
    ];
    const [reproVisible, setReproVisible] = useState(false);
    const [reproViaje, setReproViaje] = useState(null);
    const [reproEtapas, setReproEtapas] = useState(ETAPAS_REPRO.map(e => e.value));
    const [reproMotivo, setReproMotivo] = useState('');
    const [reproEstados, setReproEstados] = useState({}); // viajeId -> {estado, etapaActual, errorDetalle}

    const abrirAccion = (tipo, rowData) => {
        setAccionTipo(tipo);
        setAccionViaje(rowData);
        setAccionMotivo('');
        setAccionDestino('');
        setAccionReactivarBooking(false);
        setAccionVisible(true);
    };

    const confirmarAccion = async () => {
        // RF-LOG: el motivo es obligatorio en las tres acciones
        if (!accionMotivo || !accionMotivo.trim()) {
            toast.current.show({ severity: 'warn', summary: 'Falta el motivo', detail: 'El motivo es obligatorio', life: 4000 });
            return;
        }
        try {
            setBlocked(true);
            if (accionTipo === 'anular') {
                await anularViaje(accionViaje.viajeId, accionMotivo, accionReactivarBooking);
            } else if (accionTipo === 'reactivar') {
                await reactivarViaje(accionViaje.viajeId, accionMotivo);
            } else if (accionTipo === 'atabnp') {
                await guardarAtaBnp(accionViaje.viajeId, accionDestino, accionMotivo);
            } else if (accionTipo === 'destino') {
                if (!accionDestino || !accionDestino.trim()) {
                    toast.current.show({ severity: 'warn', summary: 'Falta el destino', detail: 'Indique el nuevo destino', life: 4000 });
                    setBlocked(false);
                    return;
                }
                await cambiarDestino(accionViaje.viajeId, accionDestino, accionMotivo);
            }
            toast.current.show({ severity: 'success', summary: 'Listo', detail: 'Acción registrada', life: 3000 });
            setAccionVisible(false);
        } catch (e) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 6000 });
        } finally {
            setBlocked(false);
        }
    };

    const verLog = async (rowData) => {
        try {
            setBlocked(true);
            const data = rowData.viajeId ? await logViaje(rowData.viajeId) : await logBooking(rowData.bookingId);
            setLogFilas(data || []);
            setLogVisible(true);
        } catch (e) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 6000 });
        } finally {
            setBlocked(false);
        }
    };

    const abrirRepro = (rowData) => {
        setReproViaje(rowData);
        setReproEtapas(ETAPAS_REPRO.map(e => e.value));
        setReproMotivo('');
        setReproVisible(true);
    };

    const confirmarRepro = async () => {
        if (!reproMotivo || !reproMotivo.trim()) {
            toast.current.show({ severity: 'warn', summary: 'Falta el motivo', detail: 'El motivo es obligatorio', life: 4000 });
            return;
        }
        if (!reproEtapas || !reproEtapas.length) {
            toast.current.show({ severity: 'warn', summary: 'Elegí etapas', detail: 'Seleccioná al menos una etapa', life: 4000 });
            return;
        }
        try {
            setBlocked(true);
            await reprocesarViaje(reproViaje.viajeId, reproEtapas, reproMotivo);
            setReproEstados(prev => ({ ...prev, [reproViaje.viajeId]: { estado: 'EN_COLA' } }));
            toast.current.show({ severity: 'success', summary: 'Encolado', detail: 'El reproceso quedó en cola', life: 3000 });
            setReproVisible(false);
        } catch (e) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 6000 });
        } finally {
            setBlocked(false);
        }
    };

    // Carga los estados de reproceso de los viajes visibles (acotado para no hacer ráfagas)
    useEffect(() => {
        const ids = (viajes || []).filter(v => v.viajeId).map(v => v.viajeId);
        if (!ids.length || ids.length > 80) return;
        let cancel = false;
        Promise.all(ids.map(id => reprocesoEstado(id).then(e => ({ id, e })).catch(() => ({ id, e: null }))))
            .then(res => {
                if (cancel) return;
                const m = {};
                res.forEach(({ id, e }) => { if (e && e.estado) m[id] = e; });
                setReproEstados(m);
            });
        return () => { cancel = true; };
    }, [viajes]);

    // Polling de los reprocesos en curso (EN_COLA / PROCESANDO) hasta que terminen
    useEffect(() => {
        const enCurso = Object.entries(reproEstados)
            .filter(([, e]) => e && (e.estado === 'EN_COLA' || e.estado === 'PROCESANDO'))
            .map(([id]) => parseInt(id, 10));
        if (!enCurso.length) return;
        const t = setInterval(() => {
            enCurso.forEach(id => reprocesoEstado(id)
                .then(e => setReproEstados(prev => ({ ...prev, [id]: e })))
                .catch(() => { }));
        }, 4000);
        return () => clearInterval(t);
    }, [reproEstados]);

    /** Badge del estado del último reproceso del viaje (RF-A10). */
    const reprocesoBadge = (rowData) => {
        const e = rowData.viajeId ? reproEstados[rowData.viajeId] : null;
        if (!e || !e.estado) return null;
        const map = {
            EN_COLA: { label: 'En cola', cls: 'p-badge-secondary' },
            PROCESANDO: { label: 'Reprocesando' + (e.etapaActual ? ' · ' + e.etapaActual : ''), cls: 'p-badge-warning' },
            OK: { label: 'Reproceso listo', cls: 'p-badge-success' },
            // el camion aun no entro al radio del destino: no se corrigio nada (Caso 20261103_0830)
            SIN_LLEGADA: { label: 'Sin llegada a destino', cls: 'p-badge-warning' },
            ERROR: { label: 'Reproceso: error', cls: 'p-badge-danger' },
        };
        const m = map[e.estado] || { label: e.estado, cls: 'p-badge-info' };
        return <span className={'p-badge ' + m.cls} title={e.errorDetalle || ''}>{m.label}</span>;
    };

    // Acciones por fila condensadas en una sola tuerca (menu desplegable) para no
    // ocupar tanto ancho de grilla. Menu unico compartido; el modelo se arma para
    // la fila cuya tuerca se toco.
    const accionesMenu = useRef(null);
    const [accionRow, setAccionRow] = useState(null);

    // Rol de solo lectura restringido (barcos Dole / reestiba-tipo camion / lleno).
    // El backend fuerza el filtro de datos; el front oculta las acciones de mutacion.
    const esAnden = (() => {
        try { return (JSON.parse(localStorage.getItem('roles')) || []).includes('DOLE-ANDEN'); }
        catch (e) { return false; }
    })();

    const buildAccionesModel = (rowData) => {
        if (!rowData) {
            return [];
        }
        const anulado = rowData.estado === 'Anulado';
        // Rol DOLE-ANDEN: SOLO LECTURA -> unicamente acciones de consulta (sin mutaciones).
        if (esAnden) {
            return [
                { label: 'Ver detalle', icon: 'pi pi-window-maximize',
                    command: () => { setDetalleViaje(rowData); setDetalleVisible(true); } },
                { label: 'Ver recorrido en mapa', icon: 'pi pi-map-marker',
                    command: () => verRecorrido(rowData) },
                { label: 'Ver log de cambios', icon: 'pi pi-history',
                    command: () => verLog(rowData) },
            ];
        }
        return [
            { label: 'Ver detalle', icon: 'pi pi-window-maximize',
                command: () => { setDetalleViaje(rowData); setDetalleVisible(true); } },
            { label: 'Ver recorrido en mapa', icon: 'pi pi-map-marker',
                command: () => verRecorrido(rowData) },
            { separator: true },
            anulado
                ? { label: 'Reactivar viaje', icon: 'pi pi-replay',
                    command: () => abrirAccion('reactivar', rowData) }
                : { label: 'Anular viaje', icon: 'pi pi-times',
                    command: () => abrirAccion('anular', rowData) },
            { label: 'Cambiar destino / planta', icon: 'pi pi-directions',
                command: () => abrirAccion('destino', rowData) },
            { label: 'Cargar / corregir ATA BNP', icon: 'pi pi-calendar-plus',
                command: () => abrirAccion('atabnp', rowData) },
            { label: 'Reprocesar viaje (recalcular etapas / estado)', icon: 'pi pi-sync',
                command: () => abrirRepro(rowData) },
            { separator: true },
            { label: 'Ver log de cambios', icon: 'pi pi-history',
                command: () => verLog(rowData) },
        ];
    };

    /** Acciones por fila: una sola tuerca que despliega el menu con todas las acciones. */
    const accionesDoleBodyTemplate = (rowData) => {
        if (!rowData.viajeId) {
            return "";  // booking sin viaje (No Despachado)
        }
        const badge = reprocesoBadge(rowData);
        return (
            <div className="flex align-items-center gap-1">
                <Button icon="pi pi-cog"
                    className="p-button-secondary p-button-text p-button-rounded"
                    style={{ width: '1.7rem', height: '1.7rem', padding: 0 }}
                    tooltip="Acciones" tooltipOptions={{ position: 'top' }}
                    onClick={(e) => { setAccionRow(rowData); accionesMenu.current.toggle(e); }}
                    aria-haspopup aria-controls="acciones_menu_popup" />
                {badge}
            </div>
        );
    };

    // Detalle del viaje en formulario (mejor lectura que la grilla ancha).
    const [detalleViaje, setDetalleViaje] = useState(null);
    const [detalleVisible, setDetalleVisible] = useState(false);

    // ── DE DONDE SALE CADA FECHA ────────────────────────────────────────────
    // Este diccionario es la fuente de la ayuda en pantalla: el ícono junto al
    // título de cada columna y el panel «¿Cómo se calculan estas fechas?».
    //
    // Vive acá, al lado de las columnas, A PROPOSITO: cuando se cambia una regla
    // del motor hay que cambiar el texto en el mismo commit. Un documento aparte
    // envejece; esto no, porque se lee en la misma pantalla donde está el dato.
    //
    // Escrito en el idioma de operación, no en SQL. Si una regla no se puede
    // explicar en dos líneas, la regla es el problema, no el texto.
    const AYUDA_CAMPOS = {
        bookingFechaCarga: 'Cuándo se cargó el booking al sistema, desde el archivo o a mano.',
        bitacoraFechaTurno: 'Fecha del turno de la bitácora en que se asignó el candado.',
        bitacoraFechaIngreso: 'Cuándo el guardia registró el ingreso en la bitácora.',
        fechaPlanificacion: 'Día para el que se planificó el viaje.',
        fechaViaje: 'Cuándo se creó el viaje en el sistema.',
        fechaViajeInicio: 'Cuándo el viaje se dio por iniciado. En el VACÍO es la asignación del candado en el patio. '
            + 'En el LLENO es cuando ya cargó y arrancó: exige que el candado se haya cerrado en la finca y que después '
            + 'el camión se aleje del radio con velocidad. Es la base del ETA R10, así que si se corre, el ETA se corre con ella.',
        motivoInicio: 'Por qué el lleno pasó a En Ruta: «salida con candado cerrado» es el caso normal; '
            + '«salida sin cierre de candado» significa que el candado nunca cerró y salió por el plazo configurado.',
        fechaViajeFin: 'Cuándo cerró el viaje. Mirá «Motivo Cierre» para saber por qué: llegada a destino, pérdida de señal o reproceso.',
        fechaViajeFinEsperada: 'Llegada estimada, calculada al iniciar el viaje. De acá sale el estado «Atrasado».',
        fechaDispositivo: 'Última posición reportada por el candado. Si está vieja, el equipo dejó de transmitir.',
        candadoAperturaCarga: 'Primera vez que se abrió el candado en la finca, ya con el contenedor ahí. Marca el arranque de la carga.',
        candadoCierreCarga: 'Primera vez que el candado se cerró DESPUÉS de esa apertura. Marca el fin de la carga. '
            + 'Se busca sólo entre la llegada a la finca y la salida, para que no se confunda con el sellado del vacío en el patio.',
        candadoAperturaR10: 'Cuándo se abrió el candado ya en R10, al entregar el contenedor.',
        horasCandado: 'Horas entre el cierre del candado en finca y su apertura en R10. Es el tiempo que el contenedor viajó sellado.',
        etaR10: 'Llegada estimada a R10: fecha de inicio del lleno más el TTT de la finca (el TTT se configura en Ubicaciones).',
        ataR10: 'Llegada real a R10, tomada del GPS.',
        etaBnp: 'Salida estimada a BNP: apertura del candado en R10 más las horas configuradas. Si no hay apertura en R10, queda pendiente.',
        ataBnp: 'Llegada real a BNP. Se carga desde el archivo ATA BNP en la pantalla de Booking, o a mano.',
        llegadaPatioSeco: 'Entrada al patio seco, para los bookings que pasan por ahí.',
        salidaPatioSeco: 'Salida del patio seco hacia la finca.',
        tttHoras: 'Tiempo de tránsito terrestre de esa finca hasta R10, en horas. Se configura en el maestro de Ubicaciones.',
        distanciaKm: 'Distancia de un solo sentido hasta la finca, en km. Se configura en el maestro de Ubicaciones.',
        acercamientoMinM: 'Lo más cerca que estuvo el candado del destino, en metros. Sirve para ver por qué un viaje no cerró.',
        estadoLogistico: 'Vacío: Posicionado (llegó), En Ruta (viajando), No Despachado (todavía no salió de R9), '
            + 'Adelantados P/S (el vacío ya está en patio seco) o YILPORT (prioridad sin GPS). '
            + 'Lleno sin despachar: En proceso (sin hora de cierre del candado, la carga sigue) '
            + 'o Completos (con hora de cierre: cargado, falta salir).',
        estado: 'Estado del viaje: Standby, Activo, Atrasado, Finalizado o Anulado.',
        motivoCierre: 'Por qué cerró el viaje: llegada a destino, cierre automático por pérdida de señal, o reproceso manual.',
        estadoPosicionamiento: 'Si el viaje va A Tiempo o Atrasado respecto de la fecha esperada.',
        // DOLE tramos a puerto: lo marca el motor que sigue el candado después de R10 (solo bookings con Puerto Carga).
        puertoCarga: 'Terminal a la que va el contenedor después de R10 (columna PUERTO CARGA de la carga masiva).',
        tipoChasis: 'DOLE o TERCERO (columna TIPO CHASIS de la carga masiva).',
        tk: 'SI / NO (columna TK de la carga masiva).',
        trasladoDirecto: 'Terminal del traslado directo a puerto (columna TRASLADO DIRECTO de la carga masiva); vacío si no es traslado directo.',
        estadoPuerto: 'Dónde está el candado después de R10: EN R10, RUTA PUERTO, EN PUERTO, RUTA DEPOT o CERRADO (candado retirado en el punto de retorno).',
        alertasPuerto: 'ALERTA: el cable se abrió fuera de R10 o de un punto de retorno. DELINCUENTE: pasaron las horas configuradas desde la salida del puerto sin retirar el candado. PERMANENCIA: pasaron las horas configuradas en el puerto sin salir.',
        candadoChasisR10: 'F1 · el candado se abrió y se volvió a cerrar dentro de R10 (el guardia lo pasó al chasis).',
        salidaR10: 'F2 · primera posición fuera del radio de salida de R10.',
        ataPuerto: 'F3 · primera posición dentro del puerto (su polígono, o su punto con el radio configurado).',
        salidaPuerto: 'F4 · primera posición fuera del puerto.',
        ataRetorno: 'F5 · primera posición dentro de un punto de retorno (R9, R9 SETILSA, patios secos: los marcados en Ubicaciones).',
        retiroCandado: 'F6 · el cable se abrió dentro del punto de retorno: se retiró el candado y el tramo queda CERRADO.',
    };
    const [ayudaVisible, setAyudaVisible] = useState(false);

    // Selector de columnas de la grilla (mostrar/ocultar). Default = las esenciales
    // del sistema; el usuario elige el resto. El export/detalle no dependen de esto.
    const TODAS_COLS = [
        { key: 'bookingCodigo', label: 'Booking' }, { key: 'contenedor', label: 'Contenedor' },
        { key: 'chofer', label: 'Chofer' }, { key: 'vehiculoPlaca', label: 'Placa' }, { key: 'vehiculoChasis', label: 'Chasis' },
        { key: 'empresaTransporte', label: 'Empresa Transporte' },
        { key: 'ruta', label: 'Ruta' }, { key: 'destinoZona', label: 'Zona de Producción' },
        { key: 'destinoCodigoPlantaEmpacadora', label: 'Cod. Planta Empacadora' }, { key: 'destinoSector', label: 'Sector' },
        { key: 'bitacoraFechaTurno', label: 'F. Bitácora Turno' }, { key: 'bitacoraFechaIngreso', label: 'F. Bitácora Ingreso' },
        { key: 'bookingFechaCarga', label: 'F. Booking Carga' }, { key: 'bookingUsuarioCarga', label: 'Booking Cargado Por' },
        { key: 'tipoViaje', label: 'Tipo Viaje' }, { key: 'fechaDispositivo', label: 'F. Dispositivo Actual' },
        { key: 'fechaPlanificacion', label: 'F. Planificación' }, { key: 'fechaViaje', label: 'F. Viaje' },
        { key: 'fechaViajeInicio', label: 'F. Inicio' }, { key: 'fechaViajeFinEsperada', label: 'F. Viaje Esperada' },
        { key: 'tiempoViajeFaltante', label: 'T.V.Faltante (min)' }, { key: 'fechaViajeFin', label: 'F. Fin' },
        { key: 'tiempoViaje', label: 'T.Viaje' }, { key: 'tiempoViajeHoras', label: 'T.Viaje (horas)' },
        { key: 'horasEnTexto', label: 'T.V.Faltante (horas)' }, { key: 'horasEnTextoGoogle', label: 'T.V.F Google (horas)' },
        { key: 'tiempoViajeFaltanteGoogle', label: 'T.V.F Google (min)' }, { key: 'categoriaContenedor', label: 'Categoría' },
        { key: 'barcoViaje', label: 'Barco-Viaje' }, { key: 'barcoNombre', label: 'Nombre del Barco' }, { key: 'prioridadVacio', label: 'Prioridad Vacío' },
        { key: 'llegadaPatioSeco', label: 'F. Llegada Patio Seco' }, { key: 'salidaPatioSeco', label: 'F. Salida Patio Seco' },
        { key: 'etaR10', label: 'ETA R10' }, { key: 'ataR10', label: 'ATA R10' },
        { key: 'etaBnp', label: 'ETA BNP' }, { key: 'ataBnp', label: 'ATA BNP' },
        { key: 'candadoAperturaCarga', label: 'Candado Apertura Carga' }, { key: 'candadoCierreCarga', label: 'Candado Cierre Carga' },
        { key: 'candadoAperturaR10', label: 'Candado Apertura R10' },
        { key: 'horasCandado', label: 'Horas Candado (Cierre → R10)' },
        { key: 'actualizarGps', label: 'Actualizar' },
        { key: 'posicionGps', label: 'PosiciónGps' }, { key: 'puntoCercano', label: 'Último Punto Logístico' }, { key: 'estadoLogistico', label: 'Estado Logístico' },
        { key: 'estado', label: 'Estado Viaje' }, { key: 'motivoCierre', label: 'Motivo Cierre' },
        { key: 'motivoInicio', label: 'Motivo Inicio' },
        { key: 'estadoPosicionamiento', label: 'Estado de Posicionamiento / Retiro' }, { key: 'acercamientoMinM', label: 'Acercamiento (m)' },
        { key: 'tttHoras', label: 'TTT (h)' },
        { key: 'distanciaKm', label: 'Distancia (km)' },
        { key: 'puertoCarga', label: 'Puerto Carga' },
        { key: 'tipoChasis', label: 'Tipo Chasis' }, { key: 'tk', label: 'TK' }, { key: 'trasladoDirecto', label: 'Traslado Directo' },
        { key: 'estadoPuerto', label: 'Estado Tramo Puerto' },
        { key: 'alertasPuerto', label: 'Alertas Tramo Puerto' },
        { key: 'candadoChasisR10', label: 'F1 Candado Chasis R10' }, { key: 'salidaR10', label: 'F2 Salida R10' },
        { key: 'ataPuerto', label: 'F3 ATA Puerto' }, { key: 'salidaPuerto', label: 'F4 Salida Puerto' },
        { key: 'ataRetorno', label: 'F5 ATA Retorno' }, { key: 'retiroCandado', label: 'F6 Retiro Candado' },
    ];
    // B1: por defecto se muestran TODAS las columnas (paridad con el grid anterior,
    // que mostraba todo). El usuario oculta lo que no quiera desde el selector.
    const COLS_DEFAULT = TODAS_COLS.map(c => c.key);
    // Preferencia de columnas (visibilidad + ORDEN) persistida POR USUARIO en el servidor
    // (endpoint usuario-preferencia). localStorage queda como cache instantaneo / fallback
    // offline: se pinta al toque desde el navegador y luego el servidor manda (fuente de verdad).
    const LS_COLS = 'logistica_cols_v1';
    const PREF_CLAVE = 'logistica_cols_detalle';
    const prefUrl = () => `${process.env.REACT_APP_API_URL || ''}/usuario-preferencia/${PREF_CLAVE}`;
    const authHeaders = () => ({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + (localStorage.getItem('jwt') || '').replaceAll('"', '')
    });
    const colsValidas = (arr) => Array.isArray(arr) ? arr.filter(k => TODAS_COLS.some(t => t.key === k)) : [];

    // La preferencia guarda { cols, catalogo }: 'cols' es lo que el usuario eligió
    // (visibilidad + orden) y 'catalogo' son TODAS las columnas que existían cuando
    // guardó. Sirve para distinguir "esta columna la oculté" de "esta columna todavía
    // no existía": las que no estaban en el catalogo son NUEVAS y se muestran solas.
    //
    // Sin esto, una columna agregada despues quedaba invisible para todo el que ya
    // tuviera preferencia guardada — y como el export usa colsVisibles, tampoco salia
    // en el Excel. Paso con "Horas Candado" y habia que marcarla a mano.
    //
    // Formato viejo (array plano): se asume catalogo = cols, asi que las columnas
    // agregadas despues de esa preferencia aparecen. Es la migracion natural.
    const parsePref = (raw) => {
        try {
            const p = typeof raw === 'string' ? JSON.parse(raw) : raw;
            if (Array.isArray(p)) return { cols: p, catalogo: p };
            if (p && Array.isArray(p.cols)) {
                return { cols: p.cols, catalogo: Array.isArray(p.catalogo) ? p.catalogo : p.cols };
            }
        } catch (e) { /* preferencia corrupta -> default */ }
        return null;
    };
    // Aplica la preferencia sumandole las columnas que nacieron despues (al final).
    const colsDesdePref = (pref) => {
        if (!pref) return null;
        const cols = colsValidas(pref.cols);
        if (!cols.length) return null;
        const nuevas = TODAS_COLS.map(t => t.key)
            .filter(k => !pref.catalogo.includes(k) && !cols.includes(k));
        return cols.concat(nuevas);
    };

    const [colsVisibles, setColsVisibles] = useState(() => {
        const desdeCache = colsDesdePref(parsePref(localStorage.getItem(LS_COLS)));
        return desdeCache || COLS_DEFAULT;
    });
    // Si el usuario ya tocó las columnas, la carga inicial del servidor no debe pisarlo.
    const usuarioTocoCols = useRef(false);
    // Carga inicial de la preferencia del usuario desde el servidor (fuente de verdad).
    useEffect(() => {
        fetch(prefUrl(), { headers: authHeaders() })
            .then(r => r.ok ? r.json() : null)
            .then(data => {
                if (data && data.valor && !usuarioTocoCols.current) {
                    const desdeServidor = colsDesdePref(parsePref(data.valor));
                    if (desdeServidor) setColsVisibles(desdeServidor);
                }
            })
            .catch(() => { /* sin conexion -> queda lo de localStorage/default */ });
    }, []);
    // Cache local siempre (pintado instantáneo / fallback offline).
    useEffect(() => {
        try {
            localStorage.setItem(LS_COLS, JSON.stringify({ cols: colsVisibles, catalogo: TODAS_COLS.map(t => t.key) }));
        } catch (e) { /* noop */ }
    }, [colsVisibles]);
    // Guarda la preferencia (orden + visibilidad) del usuario en el servidor y AVISA (toast).
    // Se llama desde cada acción del usuario: reordenar, mostrar/ocultar o restablecer.
    const persistirCols = (nuevo) => {
        usuarioTocoCols.current = true;
        setColsVisibles(nuevo);
        // Se guarda junto al catalogo vigente para que una columna agregada mas
        // adelante se distinga de una que el usuario oculto a proposito (ver parsePref).
        const payload = JSON.stringify({ cols: nuevo, catalogo: TODAS_COLS.map(t => t.key) });
        fetch(prefUrl(), { method: 'PUT', headers: authHeaders(), body: JSON.stringify({ valor: payload }) })
            .then(r => {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                if (toast.current) toast.current.show({ severity: 'success', summary: 'Columnas guardadas', detail: 'Tu configuración quedó guardada para tu usuario', life: 1800 });
            })
            .catch(() => {
                if (toast.current) toast.current.show({ severity: 'warn', summary: 'Guardado solo local', detail: 'No se pudo guardar en el servidor; quedó en este navegador', life: 3000 });
            });
    };
    // Reordenamiento por drag&drop de la grilla: guarda el nuevo orden de las columnas visibles.
    const onColReorder = (e) => {
        const cols = e.columns || [];
        const nuevoOrden = cols
            .map(col => col && col.props ? col.props.columnKey : undefined)
            .filter(k => k && TODAS_COLS.some(t => t.key === k));
        if (nuevoOrden.length) persistirCols(nuevoOrden);
    };
    const cv = (k) => colsVisibles.includes(k);
    // Ampliar la grilla a pantalla completa (toma todo el viewport).
    const [tablaAmpliada, setTablaAmpliada] = useState(false);

    // ---- Filtros nuevos DOLE (RF-C1) ----
    const [categorias, setCategorias] = useState([]);
    const [barcoViaje, setBarcoViaje] = useState(null);
    const [zonaProduccion, setZonaProduccion] = useState(null);
    const [soloAnden, setSoloAnden] = useState(false);
    const [listaCategoria, setListaCategoria] = useState([]);
    const [listaZona, setListaZona] = useState([]);

    // Maestros DOLE para los combos (grupos DOL-0000-*)
    useEffect(() => {
        const url = process.env.REACT_APP_API_URL || '';
        const cargar = (grupo, setter) => {
            fetch(`${url}/maestro-dole/grupo/${grupo}`, {
                headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('jwt') || '').replaceAll('"', '') }
            })
                .then(r => r.ok ? r.json() : [])
                .then(data => setter((data || []).map(d => d.nombre)))
                .catch(() => setter([]));
        };
        cargar('DOL-0000-0003', setListaCategoria);   // CATEGORIA CONTENEDOR
        cargar('DOL-0000-0002', setListaZona);        // ZONA PRODUCCION
    }, []);

    // Ubicaciones (maestro) para el combo de "Cambiar destino / planta" (A5):
    // el nuevo destino se ELIGE del maestro, no se escribe libre.
    const [listaUbicacionesDestino, setListaUbicacionesDestino] = useState([]);
    useEffect(() => {
        new UbicacionesService().getListaUbicaciones()
            .then(data => setListaUbicacionesDestino(ubicacionesDeViaje(data).map(d => ({
                codigo: d.codigo, nombreTmp: (d.codigo + ' - ' + (d.nombre || ''))
            }))))
            .catch(() => setListaUbicacionesDestino([]));
    }, []);

    // ---- RF-A6: selección múltiple de días (cruce de fin de año) ----
    // Una semana puede tener días de dos meses/años (ej. semana 1 de 2027 incluye
    // 30 y 31-dic-2026). Se consulta la semana completa y acá se tildan los días,
    // así no se pierden registros de ninguno de los dos años.
    const [diasSeleccionados, setDiasSeleccionados] = useState([]);
    // Control de tramos (patio seco / solo chasis): filtros de la última búsqueda; null = todavía no se buscó
    const [filtroTramos, setFiltroTramos] = useState(null);

    /**
     * RF-C1: filtros previos sobre la grilla ya consultada.
     * "Andén" acota a contenedores Reestiba / Tipo Camión y solo el tramo Lleno.
     */
    // Filtros finos (barco/categoria/zona/anden): aplican tanto a la semana como al mes.
    const filtrosFinos = (lista) => {
        let out = lista || [];
        if (categorias && categorias.length) {
            out = out.filter(v => categorias.includes(v.categoriaContenedor));
        }
        if (barcoViaje) {
            out = out.filter(v => (v.barcoViaje || '').toUpperCase().includes(barcoViaje.toUpperCase()));
        }
        if (zonaProduccion) {
            out = out.filter(v => v.destinoZona === zonaProduccion);
        }
        if (soloAnden) {
            out = out.filter(v =>
                (v.categoriaContenedor === 'REESTIBA' || v.categoriaContenedor === 'TIPO CAMION')
                && (v.tipoViaje === 'LLENO' || (v.tipoViaje && v.tipoViaje.nombre === 'LLENO')));
        }
        return out;
    };
    const viajesFiltrados = (lista) => {
        let out = filtrosFinos(lista);
        if (diasSeleccionados && diasSeleccionados.length > 0) {
            out = out.filter(v => diasSeleccionados.includes(String(v.diaSemana)));
        }
        return out;
    };

    // Pie de estados calculado desde la tabla YA filtrada (refleja barco/categoria/zona/anden).
    const buildPieData = (lista) => {
        // los estados en la lista vienen SIN espacios (removeSpaces): 'Posicionado','EnRuta','NoDespachado'.
        // Normalizamos por las dudas y contamos con esas claves; el label visible se muestra legible.
        const norm = (s) => (s || '').replace(/\s+/g, '');
        // OJO: la clave va sin espacios (removeSpaces ya corrio sobre la lista), por eso
        // 'Adelantados P/S' entra como 'AdelantadosP/S'.
        const counts = { 'Posicionado': 0, 'EnRuta': 0, 'NoDespachado': 0, 'YILPORT': 0, 'AdelantadosP/S': 0,
                         'Enproceso': 0, 'Completos': 0 };
        (lista || []).forEach(v => {
            const k = norm(v.estadoLogistico);
            if (counts[k] !== undefined) counts[k]++;
        });
        const ds = getComputedStyle(document.documentElement);
        // etiqueta visible + color por estado (consistente con el detalle: NoDespachado -> "En Finca")
        const meta = {
            'Posicionado':  ['Posicionado', ds.getPropertyValue('--green-500')],
            'EnRuta':       ['En Ruta', '#ffce32'],
            'NoDespachado': ['No Despachado', ds.getPropertyValue('--red-500')],
            // Prioridad sin candado GPS: no se posiciona nunca, no es una alarma.
            'YILPORT':      ['YILPORT', '#2563EB'],
            // Patio seco: el vacio ya esta adelantado al patio, no sale de R9.
            'AdelantadosP/S': ['Adelantados P/S', '#7C3AED'],
            // Lleno sin despachar, partido por el cierre del candado satelital.
            'Enproceso':    ['En proceso', '#F97316'],
            'Completos':    ['Completos', '#14B8A6']
        };
        const keys = Object.keys(counts).filter(k => counts[k] > 0);
        return {
            labels: keys.map(k => meta[k][0]),
            datasets: [{ data: keys.map(k => counts[k]), backgroundColor: keys.map(k => meta[k][1]) }]
        };
    };

    // Spinner de los graficos mientras se consulta el detalle (del que salen las barras).
    const [graficosCargando, setGraficosCargando] = useState(false);
    // Agregados backend de los graficos de barra (mes completo / semana completa), con filtros finos.
    const [mesGraficoData, setMesGraficoData] = useState({});
    const [semanaGraficoData, setSemanaGraficoData] = useState({});

    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        const today = new Date();

        // Set the current year
        setAnio(today.getFullYear());

        // Set the current month
        const currentMonth = String(today.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
        const selectedMonth = meses.find(m => m.value === currentMonth);
        setMes(selectedMonth ? selectedMonth.value : null);

        // Set the current day of the week
        const currentDay = today.getDay(); // getDay() returns 0 (Sunday) to 6 (Saturday)
        const selectedDay = dias.find(d => d.value === String(currentDay));
        setDia(selectedDay ? selectedDay.value : null);

        // Numero de semana por defecto. La semana arranca el DOMINGO, igual que el
        // backend guarda booking.semana (domingo = dia_semana 0 = primer dia de la
        // semana nueva). Se usa la fecha SIN hora para que el cambio ocurra EXACTO al
        // pasar a domingo; antes 'today' traia la hora y el Math.ceil adelantaba el
        // corte al sabado -> el filtro por defecto quedaba una semana adelantado y
        // desalineado con el backend (abrias el sabado y mostraba la semana equivocada).
        const hoySinHora = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const startOfYear = new Date(today.getFullYear(), 0, 1);
        const pastDaysOfYear = Math.floor((hoySinHora - startOfYear) / 86400000);
        const weekNumber = Math.ceil((pastDaysOfYear + startOfYear.getDay() + 1) / 7);

        _setSemana(weekNumber);
    }, []);


    // useEffect(() => {
    //     const configuracionService = new ConfiguracionService();
    //     configuracionService.getListaTipoViaje().then(data => { setListaTipoViaje(data); })
    // }, [])

    useEffect(() => {
        const configuracionService = new ConfiguracionService();
        const roles = JSON.parse(localStorage.getItem('roles'));

        configuracionService.getListaTipoViaje().then(data => {



            if (roles.includes('LOGISTICA_PRODUCCION')) {
                const vacioItem = data.find(item => item.nombre === 'VACIO');
                setListaTipoViaje([vacioItem]);
                setTipoViaje(vacioItem);
                setIsDisabled(true);
            } else {
                // el tipo CHASIS (control de tramos) tiene su propia seccion; el filtro de arriba sigue con VACIO/LLENO
                data = (data || []).filter((d) => d.codigo !== 'VIA-0000-0000-0003');
                setListaTipoViaje(data);
                const vacioItem = data.find(item => item.nombre === 'VACIO');
                if (vacioItem) {
                    setTipoViaje(vacioItem);
                }
            }
        });
    }, []);


    useEffect(() => {

        loadGoogleMaps(() => {
            setGoogleMapsReady(true);
        });

        return () => {
            removeGoogleMaps();
        };
    }, []);

    // Misma etiqueta que usa el backend (ViajeService.ZONA_NO_RESUELTA). Cubre los
    // bookings sin viaje cuya finca no resuelve zona; ademas evita que quede una
    // fila SIN NOMBRE en el resumen si alguna otra fila llegara sin zona.
    const ZONA_NO_RESUELTA = 'SIN ZONA / CÓDIGO DUPLICADO';

    const processData = (data) => {
        const result = [];
        const zoneMap = new Map();

        data.forEach((item) => {
            const zone = item.destinoZona || ZONA_NO_RESUELTA;
            const estado = item.estadoLogistico;

            if (!zoneMap.has(zone)) {
                zoneMap.set(zone, { noDespachado: 0, enRuta: 0, posicionado: 0, yilport: 0, adelantadosPS: 0,
                                    enProceso: 0, completos: 0 });
            }

            const zoneData = zoneMap.get(zone);

            if (estado === 'No Despachado') {
                zoneData.noDespachado++;
            } else if (estado === 'En Ruta') {
                zoneData.enRuta++;
            } else if (estado === 'Posicionado') {
                zoneData.posicionado++;
            } else if (estado === 'YILPORT') {
                zoneData.yilport++;
            } else if (estado === 'Adelantados P/S') {
                zoneData.adelantadosPS++;
            } else if (estado === 'En proceso') {
                zoneData.enProceso++;
            } else if (estado === 'Completos') {
                zoneData.completos++;
            }
        });

        zoneMap.forEach((value, key) => {
            result.push({
                destinoZona: key,
                noDespachado: value.noDespachado,
                enRuta: value.enRuta,
                posicionado: value.posicionado,
                yilport: value.yilport,
                adelantadosPS: value.adelantadosPS,
                enProceso: value.enProceso,
                completos: value.completos,
                total: value.noDespachado + value.enRuta + value.posicionado + value.yilport
                    + value.adelantadosPS + value.enProceso + value.completos
            });
        });

        return result;
    };

    // RF-C3: se renombran las descripciones del Estado Logistico. Solo cambia la
    // ETIQUETA que ve el usuario; el valor guardado en BD no se toca.
    // OJO: el valor de estadoLogistico llega SIN espacios (removeSpaces), por eso la clave
    // es 'NoDespachado' y no 'No Despachado' (sino el relabel no matchea y muestra el crudo).
    const ETIQUETA_ESTADO_LOGISTICO = {
        'NoDespachado': 'No Despachado',
        'EnRuta': 'En Ruta',
        'AdelantadosP/S': 'Adelantados P/S',
        'Enproceso': 'En proceso'
        // 'Completos' no lleva espacios: se muestra tal cual
        // 'Posicionado' se muestra tal cual (pedido cliente: no renombrar a "En R10")
    };

    const etiquetaEstadoLogistico = (valor) => ETIQUETA_ESTADO_LOGISTICO[valor] || valor;

    // Alertas del tramo a puerto en rojo: se tienen que ver sin abrir el detalle.
    const alertasPuertoBodyTemplate = (rowData) => rowData.alertasPuerto
        ? <span title={rowData.alertasPuertoDetalle || ''} style={{ color: '#B91C1C', fontWeight: 600 }}>{rowData.alertasPuerto}</span>
        : null;

    const statusLogisticoBodyTemplate = (rowData) => {
        if (rowData.estadoLogistico != null) {
            // RF-C3: la opcion "Eliminar" deja de mostrarse (no se borra el valor, solo no se muestra)
            if (rowData.estadoLogistico === 'Eliminar') {
                return "";
            }
            return <span className={`product-badge statusLogistico-${rowData.estadoLogistico.toLowerCase()}`}>{etiquetaEstadoLogistico(rowData.estadoLogistico)}</span>;
        } else {
            return "";
        }
    }

    const statusPosicionamientoBodyTemplate = (rowData) => {
        if (rowData.estadoPosicionamiento != null) {

            return <span className={`product-badge statusPosicionamiento-${rowData.estadoPosicionamiento.toLowerCase()} || ATiempo`}>{rowData.estadoPosicionamiento}</span>;
        } else {
            return "";
        }
    }




    const vermapa = (rowData) => {

        if (rowData.latitud == null) {
            mensajeNoCoordenadas();
        } else {
            let _latitudTmp = rowData.latitud;
            let _longitudTmp = rowData.longitud;

            setLatitud(parseFloat(_latitudTmp));
            setLongitud(parseFloat(_longitudTmp));

            setOptions({
                center: {
                    lat: _latitudTmp,
                    lng: _longitudTmp
                },
                zoom: 12
            });

            let newMarker = new google.maps.Marker({
                position: {
                    lat: parseFloat(rowData.latitud),
                    lng: parseFloat(rowData.longitud)
                },
                animation: google.maps.Animation.DROP,
                title: markerTitle,
                draggable: true
            });



            // Agregar marcador para destino si existen coordenadas
            if (rowData.destinoLatitud && rowData.destinoLongitud) {
                let destinoMarker = new google.maps.Marker({
                    position: {
                        lat: parseFloat(rowData.destinoLatitud),
                        lng: parseFloat(rowData.destinoLongitud)
                    },
                    animation: google.maps.Animation.DROP,
                    title: 'Destino',
                    draggable: true,
                    icon: flagIcon
                });

                destinoMarker.setMap(map);
                setOverlays([newMarker, destinoMarker]); // Agregar ambos marcadores al mapa
            } else {
                newMarker.setMap(map);
                setOverlays([newMarker]); // Solo agregar el marcador de origen
            }

            setDisplayMapa(true);
        }
    };



    const actualizarGps = (rowData) => {

        if (rowData.viajeId == null) {
            mensajeNoCoordenadasParaActualizar();
        } else {

            //buscar();
            const logisticaService = new LogisticaService();
            setBlocked(true);
            logisticaService.consultarViajeIdParaActualizar(rowData.viajeId).then(data => {

                let horasMinutos = data.mensajeSistema;

                if (horasMinutos >= 60) {

                    const hours = Math.floor(horasMinutos / 60);
                    const minutes = horasMinutos % 60;
                    horasMinutos = hours + " horas " + minutes + " mins ";
                } else {
                    // Return minutes as is
                    horasMinutos = horasMinutos + " mins";
                }

                let _rowData = rowData;
                const _viajes = [...viajes];
                const nodeToReplace = _viajes.find(node => node.viajeId === _rowData.viajeId);
                nodeToReplace.horasEnTextoGoogle = horasMinutos;

                setBlocked(false);

            })
        }

    }

    const posicionGpsBodyTemplate = (rowData) => {
        return <Button icon="pi pi-map" onClick={() => vermapa(rowData)} severity="info" aria-label="Mapa" />;
    }

    /** Distancia en metros entre dos coordenadas (Haversine, sin depender de la librería geometry). */
    const distanciaMetros = (lat1, lon1, lat2, lon2) => {
        const R = 6371000;
        const rad = Math.PI / 180;
        const dLat = (lat2 - lat1) * rad;
        const dLon = (lon2 - lon1) * rad;
        const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dLon / 2) ** 2;
        return 2 * R * Math.asin(Math.sqrt(a));
    };

    // DOLE tramos a puerto: el color de cada etapa después de R10 (COLOR_ETAPA) vive en logisticaTramos.js.
    // El tramo del candado del chasis va en línea punteada para distinguirlo del contenedor.
    const HECHOS_ALERTA = ['ALERTA', 'DELINCUENTE', 'PERMANENCIA'];
    const nombreCandado = (tipo) => tipo === 'CHASIS' ? 'candado del chasis' : 'candado del contenedor';

    // Datos del último recorrido abierto, para redibujar al cambiar de candado sin volver a consultar.
    const [recorridoDatos, setRecorridoDatos] = useState(null);   // { data, rowData }
    const [recorridoCandado, setRecorridoCandado] = useState('TODOS');

    /** Arma las capas del mapa. candado: 'TODOS' | 'CONTENEDOR' | 'CHASIS'. */
    const dibujarRecorrido = (data, rowData, candado) => {
        const g = window.google;
        // Solo para este visor: se descartan posiciones GPS basura (ej. (0,0) o
        // coordenadas imposibles) que caen fuera del area de operacion (Ecuador
        // continental) y hacen saltar la traza fuera del mapa.
        const enArea = (lat, lng) => lat >= -6 && lat <= 2 && lng >= -82 && lng <= -74;
        const puntos = (data.puntos || [])
            .map(p => ({ lat: parseFloat(p.lat), lng: parseFloat(p.lon) }))
            .filter(p => !isNaN(p.lat) && !isNaN(p.lng) && enArea(p.lat, p.lng));
        // El viaje LLENO hasta R10 lo hizo el candado del contenedor: con el chasis elegido no se pinta.
        const conViaje = candado !== 'CHASIS';

        const ov = [];
        const bounds = [];

        if (conViaje && puntos.length > 0) {
            ov.push(new g.maps.Polyline({ path: puntos, strokeColor: COLOR_LLENO, strokeOpacity: 0.9, strokeWeight: 3 }));
            ov.push(new g.maps.Marker({ position: puntos[0], label: { text: 'A', color: '#fff', fontWeight: 'bold' }, title: 'Inicio del recorrido' }));
            ov.push(new g.maps.Marker({ position: puntos[puntos.length - 1], label: { text: 'B', color: '#fff', fontWeight: 'bold' }, title: 'Fin del recorrido' }));
            puntos.forEach(p => bounds.push(p));
        }

        let destino = null;
        let llego = null;
        let minDist = null;
        const radio = data.radioM || 200;
        if (data.destino && data.destino.lat != null && data.destino.lon != null) {
            destino = { lat: parseFloat(data.destino.lat), lng: parseFloat(data.destino.lon) };
            if (conViaje) {
                ov.push(new g.maps.Marker({ position: destino, title: 'Destino: ' + (data.destino.nombre || ''), icon: flagIcon }));
                ov.push(new g.maps.Circle({
                    center: destino, radius: radio,
                    strokeColor: '#e53935', strokeOpacity: 0.8, strokeWeight: 2,
                    fillColor: '#e53935', fillOpacity: 0.12
                }));
                bounds.push(destino);
            }
            if (puntos.length > 0) {
                minDist = Math.min(...puntos.map(p => distanciaMetros(p.lat, p.lng, destino.lat, destino.lng)));
                llego = minDist <= radio;
            }
        }

        // DOLE tramos a puerto: lo que hizo cada candado después de R10, un color por etapa
        // (RUTA PUERTO, EN PUERTO, RUTA DEPOT), con sus fechas F1-F6 y las alertas marcadas donde pasaron.
        const tramos = (data.tramosPuerto || []);
        tramos.filter(t => candado === 'TODOS' || t.tipoCandado === candado).forEach(t => {
            const chasis = t.tipoCandado === 'CHASIS';
            const pts = (t.puntos || []).map(p => ({ lat: parseFloat(p.lat), lng: parseFloat(p.lon), etapa: p.etapa || 'RUTA PUERTO' }))
                .filter(p => !isNaN(p.lat) && !isNaN(p.lng) && enArea(p.lat, p.lng));
            tramosPorEtapa(pts).forEach(seg => {
                const color = COLOR_ETAPA[seg.etapa] || '#e53935';
                const path = seg.path.map(p => ({ lat: p.lat, lng: p.lng }));
                ov.push(new g.maps.Polyline(chasis
                    ? { path, strokeOpacity: 0, icons: [{ icon: { path: 'M 0,-1 0,1', strokeColor: color, strokeOpacity: 1, scale: 3 }, offset: '0', repeat: '12px' }] }
                    : { path, strokeColor: color, strokeOpacity: 0.9, strokeWeight: 4 }));
            });
            pts.forEach(p => bounds.push({ lat: p.lat, lng: p.lng }));
            (t.hechos || []).forEach(h => {
                const pos = { lat: parseFloat(h.lat), lng: parseFloat(h.lon) };
                if (isNaN(pos.lat) || isNaN(pos.lng)) return;
                const esAlerta = HECHOS_ALERTA.includes(h.tipo);
                ov.push(new g.maps.Marker({
                    position: pos,
                    icon: { path: g.maps.SymbolPath.CIRCLE, scale: 11, fillColor: esAlerta ? '#B91C1C' : '#1F2937', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2 },
                    label: { text: esAlerta ? '!' : h.tipo, color: '#fff', fontWeight: 'bold', fontSize: '10px' },
                    title: h.tipo + ' · ' + h.fecha + (h.detalle ? ' · ' + h.detalle : '') + ' (' + nombreCandado(t.tipoCandado) + ')',
                    zIndex: esAlerta ? 1000 : 900
                }));
                bounds.push(pos);
            });
        });

        recorridoBoundsRef.current = bounds;
        setRecorridoOverlays(ov);
        setRecorridoOptions({ center: destino || puntos[0] || { lat: -2.20584, lng: -79.90795 }, zoom: 11 });
        setRecorridoInfo({
            booking: rowData.bookingCodigo,
            destinoNombre: data.destino ? data.destino.nombre : '(destino sin geocerca)',
            totalPuntos: puntos.length,
            llego,
            minDist: minDist != null ? Math.round(minDist) : null,
            radio,
            estado: data.estado,
            motivoCierre: data.motivoCierre,
            estadoLogistico: data.estadoLogistico,
            tramosPuerto: tramos.map(t => ({
                tipoCandado: t.tipoCandado, candado: t.candado, estado: t.estado, puntos: (t.puntos || []).length,
                fechas: (t.hechos || []).filter(h => /^F[1-6]$/.test(h.tipo)),
                alertas: (t.hechos || []).filter(h => HECHOS_ALERTA.includes(h.tipo))
            }))
        });
    };

    /**
     * Visor de recorrido: traza la trayectoria completa del viaje (A→B), el
     * marcador del destino asignado y el círculo del radio de llegada (200 m).
     * Evidencia gráficamente si el equipo pasó o no por el destino.
     */
    const verRecorrido = (rowData) => {
        if (!rowData.viajeId) {
            return;
        }
        const g = window.google;
        if (!g || !g.maps) {
            toast.current.show({ severity: 'warn', summary: 'Recorrido', detail: 'El mapa aún se está cargando, intente de nuevo', life: 3000 });
            return;
        }
        setBlocked(true);
        recorridoViaje(rowData.viajeId).then(data => {
            setRecorridoDatos({ data, rowData });
            setRecorridoCandado('TODOS');
            dibujarRecorrido(data, rowData, 'TODOS');
            setDisplayRecorrido(true);
            setBlocked(false);
        }).catch(err => {
            setBlocked(false);
            toast.current.show({ severity: 'error', summary: 'Recorrido', detail: err.message || 'No se pudo cargar el recorrido', life: 4000 });
        });
    };

    /** Cambia el candado que se ve en el mapa (cuando el viaje tiene contenedor y chasis). */
    const elegirCandadoRecorrido = (candado) => {
        if (!candado || !recorridoDatos) return;
        setRecorridoCandado(candado);
        dibujarRecorrido(recorridoDatos.data, recorridoDatos.rowData, candado);
    };

    /** Al abrir el mapa de recorrido, encuadra la vista sobre toda la trayectoria + destino. */
    const onRecorridoMapReady = (event) => {
        const g = window.google;
        const m = event && event.map;
        if (!m || !g || !g.maps) {
            return;
        }
        const pts = recorridoBoundsRef.current || [];
        if (pts.length > 1) {
            const b = new g.maps.LatLngBounds();
            pts.forEach(p => b.extend(p));
            m.fitBounds(b);
        }
    };

    const actualizarGpsBodyTemplate = (rowData) => {
        return <Button icon="pi pi-refresh" onClick={() => actualizarGps(rowData)} className="p-button-warning" aria-label="Actualizar" />;
    }


    const formatearFecha = (fecha, formato = 'yyyy-mm-dd hh:mm:ss') => {

        let d = new Date(fecha),
            month = ("0" + (d.getMonth() + 1)).slice(-2),
            day = ("0" + d.getDate()).slice(-2),
            year = d.getFullYear(),
            hour = ("0" + d.getHours()).slice(-2),
            minutes = ("0" + d.getMinutes()).slice(-2),
            seconds = ("0" + d.getSeconds()).slice(-2);

        switch (formato) {
            case 'dd-mm-yyyy': return [day, month, year].join('-');
            case 'yyyy-mm-dd hh:mm:ss': return [year, month, day].join('-').concat(' ').concat([hour, minutes, seconds].join(':'));
            default: return [year, month, day].join('-');
        }
    }


    const formatearFechaDispositivo = (fecha, formato = 'dd-mm-yyyy hh:mm:ss') => {

        let d = new Date(fecha),
            month = ("0" + (d.getMonth() + 1)).slice(-2),
            day = ("0" + d.getDate()).slice(-2),
            year = d.getFullYear(),
            hour = ("0" + d.getHours()).slice(-2),
            minutes = ("0" + d.getMinutes()).slice(-2),
            seconds = ("0" + d.getSeconds()).slice(-2);

        switch (formato) {
            case 'dd-mm-yyyy hh:mm:ss': return [day, month, year].join('-').concat(' ').concat([hour, minutes, seconds].join(':'));
            case 'yyyy-mm-dd hh:mm:ss': return [year, month, day].join('-').concat(' ').concat([hour, minutes, seconds].join(':'));
            default: return [year, month, day].join('-');
        }
    }

    const formatearFechaPlanificacion = (fecha, formato = 'dd-mm-yyyy') => {

        const myArray = fecha.split("-");
        let _dia = myArray[0];
        let _mes = myArray[1];
        let _anio = myArray[2];

        let d = new Date(_mes + "-" + _dia + "-" + _anio),
            month = ("0" + (d.getMonth() + 1)).slice(-2),
            day = ("0" + d.getDate()).slice(-2),
            year = d.getFullYear(),
            hour = ("0" + d.getHours()).slice(-2),
            minutes = ("0" + d.getMinutes()).slice(-2),
            seconds = ("0" + d.getSeconds()).slice(-2);


        switch (formato) {
            case 'dd-mm-yyyy': return [day, month, year].join('-');
            case 'yyyy-mm-dd hh:mm:ss': return [year, month, day].join('-').concat(' ').concat([hour, minutes, seconds].join(':'));
            default: return [year, month, day].join('-');
        }
    }


    const formatearFechaViajeFin = (fecha, formato = 'hh:mm:ss') => {

        let d = new Date(fecha),
            month = ("0" + (d.getMonth() + 1)).slice(-2),
            day = ("0" + d.getDate()).slice(-2),
            year = d.getFullYear(),
            hour = ("0" + d.getHours()).slice(-2),
            minutes = ("0" + d.getMinutes()).slice(-2),
            seconds = ("0" + d.getSeconds()).slice(-2);

        switch (formato) {
            case 'hh:mm:ss': return [hour, minutes, seconds].join(':');
            case 'yyyy-mm-dd hh:mm:ss': return [year, month, day].join('-').concat(' ').concat([hour, minutes, seconds].join(':'));
            default: return [year, month, day].join('-');
        }
    }

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    // Columnas que representan fechas -> se exportan a Excel como celda de FECHA real (no texto),
    // para que Excel pueda hacer calculos (restas, ordenar, etc.).
    const COLS_FECHA_EXPORT = new Set(['bitacoraFechaTurno', 'bitacoraFechaIngreso', 'bookingFechaCarga',
        'fechaDispositivo', 'fechaPlanificacion', 'fechaViaje', 'fechaViajeInicio', 'fechaViajeFinEsperada',
        'fechaViajeFin', 'llegadaPatioSeco', 'salidaPatioSeco', 'etaR10', 'ataR10', 'etaBnp', 'ataBnp',
        'candadoAperturaCarga', 'candadoCierreCarga', 'candadoAperturaR10',
        'candadoChasisR10', 'salidaR10', 'ataPuerto', 'salidaPuerto', 'ataRetorno', 'retiroCandado']);

    // Convierte string 'dd-mm-yyyy[ hh:mm:ss]' o ISO / Date a un Date real (o null).
    const aFechaReal = (v) => {
        if (!v) return null;
        if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
        const s = String(v).trim();
        const m = s.match(/^(\d{2})[-/](\d{2})[-/](\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/);
        if (m) return new Date(+m[3], +m[2] - 1, +m[1], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
        const d = new Date(s);
        return isNaN(d.getTime()) ? null : d;
    };

    // Formato UNICO de fecha-hora para toda la pantalla: dd-mm-yyyy hh:mm:ss.
    // Antes cada columna mostraba lo que venia del backend (unas en ISO, otras ya
    // formateadas), asi que la grilla mezclaba '2026-08-26 21:26:45' con
    // '27-08-2026 07:43:00'. Se aplica solo al DISPLAY: el valor crudo queda en la
    // fila, que es lo que usan el ordenamiento y la exportacion.
    const fFechaHora = (v) => {
        const d = aFechaReal(v);
        if (!d) return (v == null || v === '') ? '' : String(v);
        const z = (n2) => String(n2).padStart(2, '0');
        return `${z(d.getDate())}-${z(d.getMonth() + 1)}-${d.getFullYear()} `
             + `${z(d.getHours())}:${z(d.getMinutes())}:${z(d.getSeconds())}`;
    };

    // Export a Excel (.xlsx) real: respeta columnas visibles y tipa las fechas como fecha.
    const exportarExcel = () => {
        const filas = aplicarFiltrosColumna(viajesFiltrados(viajes), filters);
        // mismo orden que la grilla (colsVisibles), excluyendo columnas de acción
        const cols = colsVisibles.map(k => TODAS_COLS.find(t => t.key === k))
            .filter(c => c && c.key !== 'actualizarGps' && c.key !== 'posicionGps');
        const valorCelda = (f, key) => {
            if (key === 'tipoViaje') return f.tipoViaje && f.tipoViaje.nombre ? f.tipoViaje.nombre : f.tipoViaje;
            return f[key];
        };
        const aoa = [cols.map(c => c.label)];
        filas.forEach(f => {
            aoa.push(cols.map(c => {
                const raw = valorCelda(f, c.key);
                if (COLS_FECHA_EXPORT.has(c.key)) { const d = aFechaReal(raw); return d != null ? d : (raw != null ? raw : ''); }
                return raw != null ? raw : '';
            }));
        });
        const ws = XLSX.utils.aoa_to_sheet(aoa, { cellDates: true, dateNF: 'dd/mm/yyyy hh:mm:ss' });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Logistica');
        const hoy = new Date();
        const stamp = `${hoy.getFullYear()}${String(hoy.getMonth() + 1).padStart(2, '0')}${String(hoy.getDate()).padStart(2, '0')}`;
        XLSX.writeFile(wb, `logistica_${stamp}.xlsx`);
    };

    const header = (
        <div className="flex align-items-center justify-content-end gap-2">
            <Button type="button" icon="pi pi-file-excel" severity="success" label="Excel" onClick={exportarExcel} data-pr-tooltip="Excel (fechas reales)" />
            <Button type="button" icon="pi pi-file" onClick={() => exportCSV(false)} data-pr-tooltip="CSV" />

        </div>


    );


    const mensajeNoTipoViajeSeleccionado = () => {
        toast.current.show({ severity: 'warn', summary: 'Warning', detail: "Seleccionar Tipo de Viaje para buscar", time: 3000 });
    }

    function removeSpaces(str) {
        return str.replace(/\s+/g, '');
    }

    const buscar = () => {
        if (tipoViaje == null || tipoViaje == "") {
            mensajeNoTipoViajeSeleccionado();
        } else if (fechaInicio != null && fechaFin != null && tipoViaje != null) {
            const logisticaService = new LogisticaService();
            setBlocked(true);

            logisticaService.consultarPorRangoDeFEchasYTipoViaje(fechaInicio, fechaFin, tipoViaje)
                .then(data => {
                    data.data.forEach(e => {
                        if (e.ruta != null && e.ruta.rutaDetalles != null && e.ruta.rutaDetalles.length > 0) {
                            const ubicacionInfoList = e.ruta.rutaDetalles
                                .filter(rutaDetalle => rutaDetalle.fin === true)
                                .map(rutaDetalle => {
                                    if (rutaDetalle.ubicacion != null && rutaDetalle.ubicacion.ubicacionInfoList != null && rutaDetalle.ubicacion.ubicacionInfoList.length > 0) {
                                        e.ubicacionInformacion = rutaDetalle.ubicacion.ubicacionInfoList[0];
                                    }
                                });
                        }

                        if (e.estadoLogistico != null) {
                            e.estadoLogistico = removeSpaces(e.estadoLogistico);
                        }

                        if (e.estadoPosicionamiento != null) {
                            e.estadoPosicionamiento = removeSpaces(e.estadoPosicionamiento);
                        }

                        if (e.dispositivoPosicion != null) {
                            e.fechaDispositivo = formatearFechaDispositivo(e.fechaDispositivo);
                            e.fechaPlanificacion = formatearFechaPlanificacion(e.fechaPlanificacion);

                            if (e.fechaViajeFin != null || e.fechaViajeFin == "") {
                                e.fechaViajeFin = e.fechaViajeFin;
                            }
                        } else {
                            e.dispositivoPosicion = "";

                            if (e.fechaPlanificacion != null) {
                                e.fechaPlanificacion = formatearFechaPlanificacion(e.fechaPlanificacion);
                            } else {
                                e.fechaPlanificacion = "";
                            }

                            if (e.fechaViajeFin != null || e.fechaViajFin == "") {
                                e.fechaViajeFin = e.fechaViajeFin;
                            }
                        }

                        if (e.tiempoViajeFaltante != null) {
                            let _minutos = e.tiempoViajeFaltante;
                            const hours = Math.floor(_minutos / 60);
                            const minutes = Math.floor(_minutos % 60);
                            e.horasEnTexto = hours > 0 ? `${hours}.${minutes} ` : (minutes > 0 && minutes < 10) ? `0.0${minutes}` : `0.${minutes}`;
                        }

                        if (e.tiempoViajeFaltanteGoogle != null) {
                            let _minutosGoogle = e.tiempoViajeFaltanteGoogle;
                            const hoursGoogle = Math.floor(_minutosGoogle / 60);
                            const minutesGoogle = Math.floor(_minutosGoogle % 60);
                            e.horasEnTextoGoogle = hoursGoogle > 0 ? `${hoursGoogle}.${minutesGoogle} ` : (minutesGoogle > 0 && minutesGoogle < 10) ? `0.0${minutesGoogle}` : `0.${minutesGoogle}`;
                        }

                        let _horasMinutosTiempoViaje = e.tiempoViaje;
                        const hoursTiempoViaje = Math.floor(_horasMinutosTiempoViaje / 60);
                        const minutesTiempoViaje = Math.floor(_horasMinutosTiempoViaje % 60);
                        e.tiempoViaje = hoursTiempoViaje > 0 ? `${hoursTiempoViaje}.${minutesTiempoViaje} ` : `0.${minutesTiempoViaje}`;

                    });
                    setBlocked(false);

                    setViajes(data.data);
                })
                .catch(error => {
                    console.error("Error al obtener datos de logística:", error);
                });



            logisticaService.consultarFechaPlanificacionTipoViaje(fechaInicio, fechaFin, tipoViaje)
                .then(data => {
                    if (!data || !data.data) {
                        console.error("Datos inválidos recibidos:", data);
                        return;
                    }

                    const _data = data.data;
                    const colorMapping = {
                        "No Despachado": documentStyle.getPropertyValue('--red-500'),
                        "Posicionado": '#ffce32',
                        "En Ruta": documentStyle.getPropertyValue('--green-500'),
                        "YILPORT": '#2563EB',
                        "Adelantados P/S": '#7C3AED',
                        "En proceso": '#F97316',
                        "Completos": '#14B8A6'
                    };

                    if (_data.labels && _data.labels.length > 0) {
                        _data.datasets.forEach(dataset => {
                            dataset.backgroundColor = _data.labels.map(label => colorMapping[label] || documentStyle.getPropertyValue('--default-color'));
                        });
                    }

                    setChartData(_data);
                })
                .catch(error => {
                    console.error("Error al obtener datos de planificación:", error);
                });

            logisticaService.consultarFechaPlanificacionSemana(fechaInicio, fechaFin, tipoViaje)
                .then(data => {
                    if (!data || !data.data) {
                        console.error("Datos inválidos recibidos:", data);
                        return;
                    }

                    const _data = data.data;
                    const colorMapping = {
                        "No Despachado": documentStyle.getPropertyValue('--red-500'),
                        "Posicionado": '#ffce32',
                        "En Ruta": documentStyle.getPropertyValue('--green-500'),
                        "YILPORT": '#2563EB',
                        "Adelantados P/S": '#7C3AED',
                        "En proceso": '#F97316',
                        "Completos": '#14B8A6'
                    };

                    _data.datasets.forEach(dataset => {
                        if (dataset && dataset.label) {
                            dataset.backgroundColor = [colorMapping[dataset.label] || documentStyle.getPropertyValue('--default-color')];
                        }
                    });

                    setSemanalBasicData(_data);
                })
                .catch(error => {
                    console.error("Error al obtener datos de planificación:", error);
                });

            logisticaService.consultarFechaPlanificacionMes(fechaInicio, fechaFin, tipoViaje)
                .then(data => {
                    if (!data || !data.data) {
                        console.error("Datos inválidos recibidos:", data);
                        return;
                    }

                    const _data = data.data;
                    const colorMapping = {
                        "No Despachado": documentStyle.getPropertyValue('--red-500'),
                        "Posicionado": '#ffce32',
                        "En Ruta": documentStyle.getPropertyValue('--green-500'),
                        "YILPORT": '#2563EB',
                        "Adelantados P/S": '#7C3AED',
                        "En proceso": '#F97316',
                        "Completos": '#14B8A6'
                    };

                    _data.datasets.forEach(dataset => {
                        if (dataset && dataset.label) {
                            dataset.backgroundColor = [colorMapping[dataset.label] || documentStyle.getPropertyValue('--default-color')];
                        }
                    });

                    setBasicData(_data);
                })
                .catch(error => {
                    console.error("Error al obtener datos de planificación:", error);
                });

            logisticaService.consultarFechaPlanificacionDia(fechaInicio, fechaFin, tipoViaje)
                .then(data => {
                    if (!data || !data.data) {
                        console.error("Datos inválidos recibidos:", data);
                        return;
                    }

                    const _data = data.data;
                    const colorMapping = {
                        "No Despachado": documentStyle.getPropertyValue('--red-500'),
                        "Posicionado": '#ffce32',
                        "En Ruta": documentStyle.getPropertyValue('--green-500'),
                        "YILPORT": '#2563EB',
                        "Adelantados P/S": '#7C3AED',
                        "En proceso": '#F97316',
                        "Completos": '#14B8A6'
                    };

                    _data.datasets.forEach(dataset => {
                        if (dataset && dataset.label) {
                            const color = colorMapping[dataset.label] || documentStyle.getPropertyValue('--default-color');
                            dataset.backgroundColor = color;
                            dataset.fill = false;
                            dataset.borderColor = color;
                            dataset.tension = 0.4;
                        }
                    });

                    setDiaData(_data);
                })
                .catch(error => {
                    console.error("Error al obtener datos de planificación:", error);
                });
        }
    };


    const fechasChange = (fechas) => {

        let _fechaInicio = formatearFecha(fechas[0]);
        let _fechaFin = "";
        if (fechas[1] === null) {
            _fechaFin = null;
        } else {
            _fechaFin = formatearFecha(fechas[1]);
            setFechaFin(_fechaFin);
        }

        setFechaInicio(_fechaInicio);
        setDates(fechas);
    }

    const labelToColorMap = {
        "No Despachado": documentStyle.getPropertyValue('--red-500'),
        "Posicionado": documentStyle.getPropertyValue('--green-500'),
        "En Ruta": '#ffce32',
    };

    const buscarLogistico2 = () => {
        const logisticaService = new LogisticaService();
        const semanaValue = (_semana === -1) ? "" : _semana;
        // Control de tramos (03/11/2026): consulta con estos mismos filtros (objeto nuevo en cada búsqueda)
        setFiltroTramos({ anio, mes, semana: _semana, dia });

        const ajustarFechasYHoras = (e) => {
            if (e.estadoLogistico != null) {
                e.estadoLogistico = removeSpaces(e.estadoLogistico);
            }
            if (e.estadoPosicionamiento != null) {
                e.estadoPosicionamiento = removeSpaces(e.estadoPosicionamiento);
            }
            if (e.dispositivoPosicion != null && e.fechaPlanificacion != null) {
                e.fechaDispositivo = formatearFechaDispositivo(e.fechaDispositivo);
                e.fechaPlanificacion = formatearFechaPlanificacion(e.fechaPlanificacion);
                if (e.fechaViajeFin != null || e.fechaViajaFin === "") {
                    e.fechaViajeFin = e.fechaViajeFin;
                }
            } else {
                e.dispositivoPosicion = "";
                e.fechaPlanificacion = e.fechaPlanificacion ? formatearFechaPlanificacion(e.fechaPlanificacion) : "";
                e.fechaViajeFin = e.fechaViajeFin || "";
            }

            let _minutos = e.tiempoViajeFaltante;
            const hours = Math.floor(_minutos / 60);
            const minutes = Math.floor(_minutos % 60);
            e.horasEnTexto = hours > 0 ? `${hours}.${minutes} ` : (minutes > 0 && minutes < 10 ? `0.0${minutes}` : `0.${minutes}`);

            let _minutosGoogle = e.tiempoViajeFaltanteGoogle;
            const hoursGoogle = Math.floor(_minutosGoogle / 60);
            const minutesGoogle = Math.floor(_minutosGoogle % 60);
            e.horasEnTextoGoogle = hoursGoogle > 0 ? `${hoursGoogle}.${minutesGoogle} ` : (minutesGoogle > 0 && minutesGoogle < 10 ? `0.0${minutesGoogle}` : `0.${minutesGoogle}`);

            if (e.tiempoViaje != null) {
                let _tiempoViajeHoras = e.tiempoViaje;
                const hoursTiempoViaje = Math.floor(_tiempoViajeHoras / 60);
                const minutesTiempoViaje = Math.floor(_tiempoViajeHoras % 60);
                e.tiempoViajeHoras = hoursTiempoViaje > 0 ? `${hoursTiempoViaje}.${minutesTiempoViaje} ` : (minutesTiempoViaje > 0 && minutesTiempoViaje < 10 ? `0.0${minutesTiempoViaje}` : `0.${minutesTiempoViaje}`);
            }
        };

        let serviceCall;
        if (booking) {
            serviceCall = logisticaService.getRepViajesPorFiltrosLogisticosYBooking(anio, mes, semanaValue, dia, tipoViaje.configuracionDetId, booking);
        } else {
            serviceCall = logisticaService.getViajesPorBookingFiltrosLogisticos2(anio, mes, semanaValue, dia, tipoViaje.configuracionDetId);
        }

        // "Viajes por Semana" sale de ESTE detalle (la semana filtrada). "Viajes por Mes" sale de
        // una consulta aparte del MES completo (semana=-1). Ambos reflejan los filtros finos (en
        // cliente). El spinner cubre las dos consultas, con piso de ~600ms para que se evidencie.
        setGraficosCargando(true);
        const inicioGraficos = Date.now();
        const detalleSemana = serviceCall.then(data => {
            console.log(data);
            setTablaInformativa(processData(data));


            data.forEach(e => {
                if (e.ruta != null && e.ruta.rutaDetalles != null && e.ruta.rutaDetalles.length > 0) {
                    const ubicacionInfoList = e.ruta.rutaDetalles.filter(rutaDetalle => rutaDetalle.fin === true)
                        .map(rutaDetalle => {
                            if (rutaDetalle.ubicacion != null && rutaDetalle.ubicacion.ubicacionInfoList != null && rutaDetalle.ubicacion.ubicacionInfoList.length > 0) {
                                e.ubicacionInformacion = rutaDetalle.ubicacion.ubicacionInfoList[0];
                            }
                        });
                }
                ajustarFechasYHoras(e);
                // Horas entre el cierre del candado en carga (finca) y su apertura en R10.
                // Se calcula una sola vez aca y se guarda como NUMERO en la fila, para que la
                // columna ordene, filtre y se exporte a Excel como numero sin tratamiento aparte.
                // Va despues de ajustarFechasYHoras porque esa funcion pasa las fechas a texto;
                // aFechaReal entiende ese formato y tambien ISO/Date.
                const _ci = aFechaReal(e.candadoCierreCarga);
                const _r10 = aFechaReal(e.candadoAperturaR10);
                e.horasCandado = (_ci && _r10)
                    ? Math.round(((_r10 - _ci) / 3600000) * 10) / 10
                    : null;   // null y no 0: falta un dato, no es que hayan pasado cero horas
            });
            setBlocked(false);
            setViajes(data);
        });

        // Graficos de barra: agregados backend LIVIANOS (no traen el detalle pesado -> no se cuelgan),
        // que respetan los filtros finos en el server. Mes = mes completo (semana=-1). Semana = la
        // semana seleccionada pero con TODOS los dias (diaSemana=-1), no solo el dia filtrado.
        const colorear = (data) => {
            const meta = { 'Posicionado': ['Posicionado', '--green-500'], 'En Ruta': ['En Ruta', null], 'No Despachado': ['No Despachado', '--red-500'], 'YILPORT': ['YILPORT', null] };
            (data.datasets || []).forEach(dataset => {
                const m = meta[dataset.label];
                const fijo = dataset.label === 'YILPORT' ? '#2563EB' : '#ffce32';
                dataset.backgroundColor = m ? (m[1] ? documentStyle.getPropertyValue(m[1]) : fijo) : documentStyle.getPropertyValue('--default-color');
                if (m) dataset.label = m[0];
            });
            return data;
        };
        const semanaFino = Number.isInteger(_semana) ? _semana : -1;
        const categoriaCsv = (categorias && categorias.length) ? categorias.join(',') : null;
        const graficoMes = logisticaService.getBookingMesFiltrosFinos(anio, mes, -1, -1, tipoViaje.codigo,
            categoriaCsv, barcoViaje || null, zonaProduccion || null, soloAnden)
            .then(data => { setMesGraficoData(colorear(data)); })
            .catch(error => { console.error("Error grafico mes:", error); setMesGraficoData({}); });

        const graficoSemana = logisticaService.getBookingSemanaFiltrosFinos(anio, mes, semanaFino, -1, tipoViaje.codigo,
            categoriaCsv, barcoViaje || null, zonaProduccion || null, soloAnden)
            .then(data => { setSemanaGraficoData(colorear(data)); })
            .catch(error => { console.error("Error grafico semana:", error); setSemanaGraficoData({}); });

        Promise.all([detalleSemana, graficoMes, graficoSemana]).finally(() => {
            const restante = Math.max(0, 600 - (Date.now() - inicioGraficos));
            setTimeout(() => setGraficosCargando(false), restante);
        });

        setBlocked(true);
        console.log(tablaInformativa);

    };


    return (
        <>
            <div className="card">
                <TabView>
                    <TabPanel header="Filtro Logístico">
                        <div className="grid p-fluid mt-3">
                            <div className="field col-6 md:col-4">
                                <span className="p-float-label">
                                    <InputNumber id="anio" useGrouping={false} value={anio} onChange={(e) => setAnio(e.value)}   />
                                    <label htmlFor="anio">Año</label>
                                </span>
                            </div>
                            <div className="field col-6 md:col-4">
                                <span className="p-float-label">
                                    <Dropdown id="mes" value={mes} onChange={(e) => setMes(e.value)} options={meses} optionLabel="name" showClear />
                                    <label htmlFor="mes">Mes</label>
                                </span>
                            </div>
                            <div className="field col-6 md:col-4">
                                <span className="p-float-label">
                                    <InputNumber id="semana" useGrouping={false} value={_semana} onChange={(e) => onChangeSemana(e.value)} min={-1} max={52} />
                                    <label htmlFor="semana">Semana</label>
                                </span>
                            </div>
                            <div className="field col-6 md:col-4">
                                <span className="p-float-label">
                                    <Dropdown id="dia" value={dia} onChange={(e) => setDia(e.value)} options={dias} optionLabel="name" showClear />
                                    <label htmlFor="dia">Día</label>
                                </span>
                            </div>
                            <div className="field col-6 md:col-4">
                                <span className="p-float-label">
                                    <Dropdown id="turnoL" value={tipoViaje} optionLabel="nombre" options={listaTipoViaje} onChange={(e) => { setTipoViaje(e.value); }} className='mr-2' disabled={isDisabled}></Dropdown>
                                    <label htmlFor="turnoL">Tipo de Viaje</label>
                                </span>
                            </div>

                            {/* RF-A6: días múltiples (cruce de fin de año) */}
                            <div className="field col-6 md:col-4">
                                <span className="p-float-label">
                                    <MultiSelect id="diasMultiple" value={diasSeleccionados} options={dias}
                                        optionLabel="name" optionValue="value" display="chip"
                                        onChange={(e) => setDiasSeleccionados((e.value || []).filter(v => v !== '-1'))}
                                        showClear />
                                    <label htmlFor="diasMultiple">Días (cruce de año)</label>
                                </span>
                            </div>
                            {/* ---- Filtros nuevos DOLE (RF-C1) ---- */}
                            <div className="field col-6 md:col-4">
                                <span className="p-float-label">
                                    <MultiSelect id="categoria" value={categorias} options={listaCategoria} onChange={(e) => setCategorias(e.value)} display="chip" showClear />
                                    <label htmlFor="categoria">Categoría de Contenedor</label>
                                </span>
                            </div>
                            <div className="field col-6 md:col-4">
                                <span className="p-float-label">
                                    <Dropdown id="zonaProduccion" value={zonaProduccion} options={listaZona} onChange={(e) => setZonaProduccion(e.value)} showClear />
                                    <label htmlFor="zonaProduccion">Zona de Producción</label>
                                </span>
                            </div>
                            <div className="field col-6 md:col-4">
                                <span className="p-float-label">
                                    <InputText id="barcoViaje" value={barcoViaje || ''} onChange={(e) => setBarcoViaje(e.target.value)} />
                                    <label htmlFor="barcoViaje">Barco-Viaje</label>
                                </span>
                            </div>
                            <div className="field col-6 md:col-4">
                                <Button label={soloAnden ? 'Andén: SÍ' : 'Andén'} icon="pi pi-filter"
                                    className={soloAnden ? 'p-button-sm' : 'p-button-sm p-button-outlined'}
                                    onClick={() => setSoloAnden(!soloAnden)}
                                    tooltip="Solo Reestiba / Tipo Camión, tramo Lleno" />
                            </div>

                            <div className="field col-6 md:col-2">
                                <span className="p-float-label">
                                    <InputText id="booking" value={booking} onChange={(e) => setBooking(e.target.value)} />
                                    <label htmlFor="booking">Booking</label>
                                </span>

                            </div>

                            <div className="field col-6 md:col-2">
                                <span className="p-float-label">
                                    <Button icon="pi pi-search" severity="success" aria-label="Search" onClick={buscarLogistico2} />
                                </span>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Filtro Operativo">
                        <div className=" flex justify-content-center">
                            <Calendar value={dates} onChange={(e) => { fechasChange(e.value) }} selectionMode="range" readOnlyInput className='mr-2' />
                            <Dropdown id="turno" value={tipoViaje} optionLabel="nombre" options={listaTipoViaje} onChange={(e) => { setTipoViaje(e.value); }} placeholder="Seleccionar Tipo Viaje" className='mr-2'></Dropdown>
                            <Button icon="pi pi-search" onClick={buscar} />
                        </div>
                    </TabPanel>

                </TabView>
            </div>

            <Accordion multiple activeIndex={[0, 1]}>
                <AccordionTab header={<React.Fragment><i className="pi pi-calendar"></i><span> Métricas</span></React.Fragment>}>
                    {(() => {
                        // PIE y SEMANA salen del detalle de la semana filtrada (client-side, reflejan
                        // filtros finos al instante). MES viene del agregado backend liviano del mes
                        // completo (mesGraficoData), que ya respeta los filtros finos en el server.
                        const filtrados = viajesFiltrados(viajes);
                        const pieData = buildPieData(filtrados);
                        const totalPie = pieData.datasets[0].data.reduce((a, b) => a + Number(b || 0), 0);
                        // Semana y Mes vienen de agregados backend (semana completa / mes completo, con
                        // filtros finos). El pie es la vista actual filtrada (incluye el dia).
                        const semanaData = (semanaGraficoData && semanaGraficoData.datasets) ? semanaGraficoData : { labels: [], datasets: [] };
                        const mesData = (mesGraficoData && mesGraficoData.datasets) ? mesGraficoData : { labels: [], datasets: [] };
                        return (
                            <BlockUI blocked={graficosCargando} template={<ProgressSpinner style={{ width: '50px', height: '50px' }} />}>
                                <div className="graficosFlex" style={{ display: "flex" }}>
                                    <div className="card" style={{ flex: 1 }}>
                                        <h5>Estados — Total: {totalPie}</h5>
                                        <Chart type="pie" data={pieData} plugins={[ChartDataLabels]} options={lightOptions} />
                                    </div>
                                    <div className="card" style={{ flex: 1 }}>
                                        <h5>Viajes por Semana</h5>
                                        <Chart type="bar" data={semanaData} plugins={[ChartDataLabels]} options={horizontalOptions} />
                                    </div>
                                    <div className="card" style={{ flex: 1 }}>
                                        <h5>Viajes por Mes</h5>
                                        <Chart type="bar" data={mesData} plugins={[ChartDataLabels]} options={basicOptions} />
                                    </div>
                                </div>
                            </BlockUI>
                        );
                    })()}


                </AccordionTab>
            </Accordion>

            {/* DOLE control de tramos (31/10/2026): patio seco y solo chasis con conteos y graficos propios, aparte de las
                metricas de arriba (que siguen solo con VACIO/LLENO). Usa los filtros de arriba desde el 03/11/2026. */}
            <Accordion>
                <AccordionTab header={<React.Fragment><i className="pi pi-sitemap"></i><span> Control de tramos: patio seco y solo chasis</span></React.Fragment>}>
                    <ControlTramos filtro={filtroTramos} />
                </AccordionTab>
            </Accordion>


            <div className="datatable-templating-demo">
                <div className="card" >
                    <Toast ref={toast} />
                    <BlockUI blocked={blocked} template={<div className="card flex justify-content-center">
                        <ProgressSpinner />
                    </div>}>
                    {(() => {
                        // Totales por columna (fila de pie).
                        const tot = (tablaInformativa || []).reduce((a, r) => {
                            a.nd += Number(r.noDespachado) || 0; a.er += Number(r.enRuta) || 0;
                            a.po += Number(r.posicionado) || 0; a.yi += Number(r.yilport) || 0;
                            a.ps += Number(r.adelantadosPS) || 0;
                            a.ep += Number(r.enProceso) || 0; a.co += Number(r.completos) || 0;
                            a.to += Number(r.total) || 0; return a;
                        }, { nd: 0, er: 0, po: 0, yi: 0, ps: 0, ep: 0, co: 0, to: 0 });
                        const fStyle = { padding: '3px 6px', fontWeight: 700 };
                        return (<>
                    <DataTable className='myWrapper resumenAuto p-datatable-wrapper' size='small' showGridlines responsiveLayout="scroll" paginator value={tablaInformativa} rows={20} rowsPerPageOptions={[20, 50, 100, 200]}>
                        <Column field="destinoZona" header="Zona de Producción" footer="TOTAL" bodyStyle={{ padding: '1px 6px' }} headerStyle={{ padding: '4px 6px' }} footerStyle={fStyle} />
                        <Column field="noDespachado" header="No Despachado" footer={tot.nd} bodyStyle={{ padding: '1px 6px' }} headerStyle={{ padding: '4px 6px' }} footerStyle={fStyle} />
                        <Column field="enRuta" header="En Ruta" footer={tot.er} bodyStyle={{ padding: '1px 6px' }} headerStyle={{ padding: '4px 6px' }} footerStyle={fStyle} />
                        <Column field="posicionado" header="Posicionado" footer={tot.po} bodyStyle={{ padding: '1px 6px' }} headerStyle={{ padding: '4px 6px' }} footerStyle={fStyle} />
                        <Column field="yilport" header="YILPORT" footer={tot.yi} bodyStyle={{ padding: '1px 6px' }} headerStyle={{ padding: '4px 6px' }} footerStyle={fStyle} />
                        <Column field="adelantadosPS" header="Adelantados P/S" footer={tot.ps} bodyStyle={{ padding: '1px 6px' }} headerStyle={{ padding: '4px 6px' }} footerStyle={fStyle} />
                        <Column field="enProceso" header="En proceso" footer={tot.ep} bodyStyle={{ padding: '1px 6px' }} headerStyle={{ padding: '4px 6px' }} footerStyle={fStyle} />
                        <Column field="completos" header="Completos" footer={tot.co} bodyStyle={{ padding: '1px 6px' }} headerStyle={{ padding: '4px 6px' }} footerStyle={fStyle} />
                        <Column field="total" header="Total" footer={tot.to} bodyStyle={{ padding: '1px 6px' }} headerStyle={{ padding: '4px 6px' }} footerStyle={fStyle} />
                    </DataTable>
                    {(() => {
                        // Codigos de finca que no resolvieron zona, listados UNA vez cada uno.
                        const conteo = new Map();
                        (viajes || []).forEach(v => {
                            if (v.zonaDetalle) conteo.set(v.zonaDetalle, (conteo.get(v.zonaDetalle) || 0) + 1);
                        });
                        const detalles = [...conteo.entries()].sort((a, b) => b[1] - a[1]);
                        if (!detalles.length) return null;
                        return (
                            <div style={{ marginTop: '0.5rem', fontSize: '0.8rem', color: '#6B7280', lineHeight: 1.5 }}>
                                <b>Revisar maestro de Ubicaciones</b> &mdash; estos códigos de finca no resuelven zona:
                                <ul style={{ margin: '0.25rem 0 0 1rem', padding: 0 }}>
                                    {detalles.map(([d, n]) => <li key={d}>{d} &mdash; {n} booking{n > 1 ? 's' : ''}</li>)}
                                </ul>
                            </div>
                        );
                    })()}
                        </>);
                    })()}

                    </BlockUI>
                </div>
            </div>

            <div className="datatable-templating-demo"
                style={tablaAmpliada ? { position: 'fixed', inset: 0, zIndex: 1100, background: 'var(--surface-ground, #ffffff)', overflow: 'auto', padding: '1rem', margin: 0 } : {}}>
                <div className="card" >
                    <Toast ref={toast} />
                    <BlockUI blocked={blocked} template={<div className="card flex justify-content-center">
                        <ProgressSpinner />
                    </div>}>


                        <div className="flex align-items-center justify-content-end gap-2 mb-2">
                            <span style={{ fontSize: '0.85rem', color: '#6B7280' }}>Columnas:</span>
                            <MultiSelect value={colsVisibles} options={TODAS_COLS} optionLabel="label" optionValue="key"
                                onChange={(e) => {
                                    const sel = e.value || [];
                                    // preservar el orden custom de las que siguen visibles; agregar las nuevas al final
                                    const kept = colsVisibles.filter(k => sel.includes(k));
                                    const added = sel.filter(k => !colsVisibles.includes(k));
                                    persistirCols([...kept, ...added]);
                                }} display="chip" filter
                                placeholder="Elegí columnas" maxSelectedLabels={3} selectedItemsLabel="{0} columnas"
                                className="w-full md:w-30rem" />
                            <Button icon="pi pi-refresh" className="p-button-sm p-button-text" tooltip="Restablecer columnas"
                                onClick={() => persistirCols(COLS_DEFAULT)} />
                            <Button icon="pi pi-info-circle" label="¿Cómo se calculan las fechas?"
                                className="p-button-sm p-button-text" onClick={() => setAyudaVisible(true)} />
                            <Button icon={tablaAmpliada ? 'pi pi-window-minimize' : 'pi pi-window-maximize'}
                                className="p-button-sm p-button-text" tooltip={tablaAmpliada ? 'Restaurar' : 'Ampliar'}
                                onClick={() => { setTablaAmpliada(v => !v); setTimeout(() => window.dispatchEvent(new Event('resize')), 150); }} />
                        </div>
                        {/* Densidad tipo Excel: texto y padding compactos, solo para esta grilla. */}
                        <style>{`
                            /* Auto-ajuste de columnas al contenido (como Excel): tabla en table-layout auto.
                               PrimeReact 8 scrollable usa UNA sola tabla, asi que el header queda alineado. */
                            .myWrapper .p-datatable-table { table-layout: auto !important; width: auto !important; min-width: 100% !important; }
                            /* Tabla resumen: solo del ancho de su contenido (no llena el contenedor). */
                            .resumenAuto .p-datatable-table { min-width: 0 !important; width: auto !important; }
                            .resumenAuto { width: auto !important; display: inline-block; }
                            /* CELULAR: forzar que las tablas NUNCA se apilen (stack). Se quedan como tabla
                               compacta con scroll horizontal. Anula cualquier media-query de stack del tema. */
                            @media (max-width: 991px) {
                                .myWrapper .p-datatable-thead > tr { display: table-row !important; }
                                .myWrapper .p-datatable-thead > tr > th { display: table-cell !important; }
                                .myWrapper .p-datatable-tbody > tr { display: table-row !important; }
                                .myWrapper .p-datatable-tbody > tr > td { display: table-cell !important; }
                                .myWrapper .p-datatable-tbody > tr > td .p-column-title { display: none !important; }
                                /* En celular el tema deja thead/tbody como tablas separadas; con un ANCHO FIJO
                                   por columna ambas usan los mismos anchos -> titulos alineados con su columna y
                                   ninguna columna vacia se infla (el balloon que rompia la grilla). Solo la grilla
                                   principal (no la tabla resumen). Verificado en el DOM: header y cuerpo mismo ancho. */
                                .myWrapper:not(.resumenAuto) .p-datatable-thead > tr > th,
                                .myWrapper:not(.resumenAuto) .p-datatable-tbody > tr > td { width: 140px !important; min-width: 140px !important; max-width: 140px !important; box-sizing: border-box !important; }
                                /* Seleccion (col 1) y Acciones (col 2) angostas, en TODAS las filas del header
                                   (titulo + filtro) y del cuerpo, para no romper la alineacion. */
                                .myWrapper:not(.resumenAuto) .p-datatable-thead th:nth-child(1),
                                .myWrapper:not(.resumenAuto) .p-datatable-tbody td:nth-child(1) { width: 36px !important; min-width: 36px !important; max-width: 36px !important; }
                                .myWrapper:not(.resumenAuto) .p-datatable-thead th:nth-child(2),
                                .myWrapper:not(.resumenAuto) .p-datatable-tbody td:nth-child(2) { width: 46px !important; min-width: 46px !important; max-width: 46px !important; }
                                /* El titulo envuelve dentro de su ancho fijo (no se desborda a la vecina). */
                                .myWrapper .p-column-header-content .p-column-title { white-space: normal !important; overflow-wrap: break-word; }
                                .myWrapper .p-datatable-thead > tr > th .p-column-header-content { align-items: flex-start; }
                                /* Graficos: apilados a ancho completo (uno debajo del otro) en celular. */
                                .graficosFlex { flex-direction: column !important; }
                                .graficosFlex > .card { width: 100% !important; }
                                /* Tabla resumen en celular: en desktop va compacta (ancho del contenido),
                                   pero en celular eso dejaba un gran hueco a la derecha. Aca se hace a ancho
                                   completo (llena la tarjeta) + tabla unica con table-layout:fixed para que
                                   titulo/cuerpo/TOTAL queden alineados y las columnas se repartan el ancho.
                                   Verificado con datos: llena el ancho, alineado, sin hueco. */
                                .p-datatable.resumenAuto { display: block !important; width: 100% !important; }
                                .resumenAuto .p-datatable-table { table-layout: fixed !important; width: 100% !important; min-width: 100% !important; }
                                .resumenAuto .p-datatable-thead { display: table-header-group !important; }
                                .resumenAuto .p-datatable-tbody { display: table-row-group !important; }
                                .resumenAuto .p-datatable-tfoot { display: table-footer-group !important; }
                            }
                            /* Densidad tipo Excel + lineas de separacion (gridlines). !important para ganarle
                               al padding del tema de PrimeReact (.p-datatable.p-datatable-sm ...), que tiene
                               mayor especificidad. */
                            .myWrapper .p-datatable-thead > tr > th,
                            .myWrapper .p-datatable-tbody > tr > td { font-size: 0.72rem !important; padding: 0.1rem 0.3rem !important; line-height: 1.05 !important; border: 1px solid var(--surface-300, #dee2e6) !important; }
                            .myWrapper .p-datatable-tbody > tr > td { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
                            .myWrapper .p-datatable-tbody > tr { height: auto !important; }
                            .myWrapper .p-column-filter { width: 100% !important; }
                            .myWrapper .p-column-filter .p-inputtext { width: 100% !important; min-width: 6rem !important; font-size: 0.7rem !important; padding: 0.1rem 0.3rem !important; }
                            .myWrapper .p-column-filter-menu-button { width: 1.3rem !important; height: 1.3rem !important; margin-left: 0.1rem !important; flex: 0 0 auto; }
                            .myWrapper .p-column-header-content .p-column-title { font-weight: 600; white-space: nowrap; }
                            /* CAUSA REAL del alto de fila: los botones (Acciones/Mapa/Actualizar, tamano normal)
                               y los badges de estado eran mas altos que el texto y estiraban TODA la fila.
                               Se compactan todos los controles del cuerpo para que la fila quede tipo Excel. */
                            .myWrapper .p-datatable-tbody .p-button { height: 1.5rem !important; min-height: 0 !important; width: auto !important; padding: 0.05rem 0.4rem !important; font-size: 0.68rem !important; }
                            .myWrapper .p-datatable-tbody .p-button.p-button-rounded { width: 1.5rem !important; padding: 0 !important; }
                            .myWrapper .p-datatable-tbody .p-button .p-button-icon { font-size: 0.72rem !important; margin: 0 !important; }
                            .myWrapper .p-datatable-tbody .product-badge { padding: 1px 6px !important; font-size: 0.62rem !important; line-height: 1.3 !important; }
                            .myWrapper .p-datatable-tbody > tr > td .flex { gap: 0.15rem !important; }
                            /* Fila(s) sombreada(s) para guiarse a lo largo de la matriz: banda ambar
                               (no el azul del tema) que resalta en todo el ancho y no tapa los badges. */
                            .myWrapper .p-datatable-tbody > tr.p-highlight > td { background: #fff3b0 !important; color: inherit !important; box-shadow: inset 0 -1px 0 #f59e0b, inset 0 1px 0 #f59e0b; }
                            .myWrapper .p-datatable-tbody > tr.p-highlight > td .product-badge { box-shadow: 0 0 0 1px rgba(0,0,0,.15); }
                        `}</style>
                        <DataTable className='myWrapper p-datatable-wrapper' ref={dt} value={viajesFiltrados(viajes)} size='small' showGridlines responsiveLayout="scroll" header={header} scrollable scrollHeight={tablaAmpliada ? "calc(100vh - 175px)" : "400px"} resizableColumns columnResizeMode="expand" reorderableColumns onColReorder={onColReorder} filters={filters} onFilter={(e) => setFilters(e.filters)} filterDisplay="row" paginator rows={200} rowsPerPageOptions={[20, 50, 100, 200]}
                            selection={filasSel} onSelectionChange={(e) => setFilasSel(e.value)} dataKey="viajeId" >
                            {/* Checkbox para sombrear una o varias filas y guiarse a lo largo de la matriz. */}
                            <Column selectionMode="multiple" exportable={false} reorderable={false} headerStyle={{ width: '2.2rem', padding: '4px 6px' }} bodyStyle={{ width: '2.2rem', padding: '1px 4px' }}></Column>
                            {/* Acciones DOLE al inicio (A1/A5/ATA/log + detalle). Fija: no se reordena. */}
                            <Column body={accionesDoleBodyTemplate} header="Acciones" exportable={false} reorderable={false} bodyStyle={{ padding: '1px 4px', whiteSpace: 'nowrap', width: '1%' }} headerStyle={{ padding: '4px 6px', whiteSpace: 'nowrap', width: '1%' }}></Column>
                            {colsVisibles.map(key => {
                                const c = TODAS_COLS.find(t => t.key === key);
                                if (!c) return null;
                                const field = (c.key === 'tipoViaje' || c.key === 'actualizarGps' || c.key === 'posicionGps') ? undefined : c.key;
                                const body = c.key === 'actualizarGps' ? actualizarGpsBodyTemplate
                                    : c.key === 'posicionGps' ? posicionGpsBodyTemplate
                                        : c.key === 'estadoLogistico' ? statusLogisticoBodyTemplate
                                            : c.key === 'estadoPosicionamiento' ? statusPosicionamientoBodyTemplate
                                            : c.key === 'alertasPuerto' ? alertasPuertoBodyTemplate
                                                : c.key === 'tipoViaje' ? (row => (row.tipoViaje && row.tipoViaje.nombre) ? row.tipoViaje.nombre : row.tipoViaje)
                                                    : COLS_FECHA_EXPORT.has(c.key) ? (row => fFechaHora(row[c.key])) : undefined;
                                const conFiltro = ['bookingCodigo', 'contenedor', 'chofer', 'vehiculoPlaca', 'vehiculoChasis',
                                    'empresaTransporte', 'ruta',
                                    'destinoZona', 'destinoCodigoPlantaEmpacadora', 'destinoSector', 'bookingUsuarioCarga',
                                    'tipoViaje', 'categoriaContenedor', 'barcoViaje', 'prioridadVacio', 'estadoLogistico',
                                    'estadoPosicionamiento', 'distanciaKm', 'motivoCierre', 'motivoInicio',
                                    'puertoCarga', 'tipoChasis', 'tk', 'trasladoDirecto', 'estadoPuerto', 'alertasPuerto'].includes(c.key);
                                // Las columnas que tienen explicación llevan un ? al lado del título.
                                // El texto sale de AYUDA_CAMPOS y se ve al pasar el cursor, sin abrir nada.
                                const ayuda = AYUDA_CAMPOS[c.key];
                                const encabezado = ayuda
                                    ? (<span>{c.label}
                                        <i className="pi pi-question-circle" title={ayuda}
                                            style={{ marginLeft: '4px', fontSize: '0.75rem', color: '#9CA3AF', cursor: 'help' }} />
                                    </span>)
                                    : c.label;
                                return (
                                    <Column key={c.key} columnKey={c.key} field={field} body={body} header={encabezado} footer={c.label}
                                        filter={conFiltro} filterPlaceholder={conFiltro ? c.label + '...' : undefined}
                                        bodyStyle={{ padding: '1px 6px', whiteSpace: 'nowrap' }} headerStyle={{ padding: '4px 6px', whiteSpace: 'nowrap' }}></Column>
                                );
                            })}
                        </DataTable>

                    </BlockUI>
                </div>
            </div>

            {/* Menu unico de acciones por fila (se despliega desde la tuerca) */}
            <Menu popup id="acciones_menu_popup" ref={accionesMenu} model={buildAccionesModel(accionRow)}
                appendTo={document.body} baseZIndex={1300} />

            {/* ---- Acciones DOLE: motivo obligatorio (RF-A1 / RF-A5 / RF-LOG) ---- */}
            <Dialog header={accionTipo === 'anular' ? 'Anular viaje'
                : accionTipo === 'reactivar' ? 'Reactivar viaje'
                : accionTipo === 'atabnp' ? 'Cargar / corregir ATA BNP' : 'Cambiar destino / planta'}
                visible={accionVisible} style={{ width: '520px' }} modal
                onHide={() => setAccionVisible(false)}
                footer={
                    <div>
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={() => setAccionVisible(false)} />
                        <Button label="Confirmar" icon="pi pi-check" onClick={confirmarAccion} />
                    </div>
                }>
                {accionViaje && (
                    <div className="grid p-fluid">
                        <div className="col-12">
                            <small>Viaje <b>{accionViaje.viajeId}</b> · Booking <b>{accionViaje.bookingCodigo}</b></small>
                        </div>
                        {accionTipo === 'anular' && (
                            <div className="col-12">
                                <small>La bitácora y el seguimiento <b>se conservan</b>; el viaje queda como registro histórico.</small>
                            </div>
                        )}
                        {accionTipo === 'atabnp' && (
                            <div className="col-12">
                                <label htmlFor="ataBnpValor">ATA BNP (yyyy-MM-dd HH:mm)</label>
                                <InputText id="ataBnpValor" value={accionDestino} onChange={(e) => setAccionDestino(e.target.value)}
                                    placeholder="2026-06-17 06:45" />
                                <small>Vacío = deja la marca como pendiente.</small>
                            </div>
                        )}
                        {accionTipo === 'destino' && (
                            <div className="col-12">
                                <label htmlFor="nuevoDestino">Nuevo destino (finca / planta)</label>
                                <Dropdown id="nuevoDestino" value={accionDestino} options={listaUbicacionesDestino}
                                    optionLabel="nombreTmp" optionValue="codigo" filter showClear
                                    onChange={(e) => setAccionDestino(e.value)}
                                    placeholder="Seleccioná el destino del maestro" className="w-full" />
                                <small>Se elige del maestro de Ubicaciones (no se escribe libre).</small>
                            </div>
                        )}
                        <div className="col-12">
                            <label htmlFor="motivoAccion">Motivo <span style={{ color: '#DC2626' }}>*</span></label>
                            <InputText id="motivoAccion" value={accionMotivo} onChange={(e) => setAccionMotivo(e.target.value)}
                                placeholder="Obligatorio: queda en el log" />
                        </div>
                        {accionTipo === 'anular' && (
                            <div className="col-12">
                                <Button label={accionReactivarBooking ? 'Reactivar Booking: SÍ' : 'Reactivar Booking: NO'}
                                    className={accionReactivarBooking ? 'p-button-sm' : 'p-button-sm p-button-outlined'}
                                    onClick={() => setAccionReactivarBooking(!accionReactivarBooking)} />
                            </div>
                        )}
                    </div>
                )}
            </Dialog>

            {/* ---- Reproceso de viaje (RF-A10): batch asíncrono con estado ---- */}
            <Dialog header="Reprocesar viaje" visible={reproVisible} style={{ width: '560px' }} modal
                onHide={() => setReproVisible(false)}
                footer={
                    <div>
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={() => setReproVisible(false)} />
                        <Button label="Reprocesar" icon="pi pi-sync" onClick={confirmarRepro} />
                    </div>
                }>
                {reproViaje && (
                    <div className="grid p-fluid">
                        <div className="col-12">
                            <small>Viaje <b>{reproViaje.viajeId}</b> · Booking <b>{reproViaje.bookingCodigo}</b></small>
                        </div>
                        <div className="col-12">
                            <small>Recalcula <b>solo este viaje</b> con la configuración vigente (Cut-Off, TTT, destino).
                                Corre en segundo plano; el avance se ve en la grilla (En cola → Reprocesando → Listo).
                                Para corregir la llegada, reprocesá <b>después</b> de que el camión entre al destino:
                                si todavía no llegó, queda en «Sin llegada a destino» y no se cambia nada.</small>
                        </div>
                        <div className="col-12">
                            <label htmlFor="reproEtapas">Etapas a reprocesar</label>
                            <MultiSelect id="reproEtapas" value={reproEtapas} options={ETAPAS_REPRO}
                                optionLabel="label" optionValue="value" display="chip"
                                onChange={(e) => setReproEtapas(e.value)} className="w-full"
                                placeholder="Seleccioná las etapas" />
                        </div>
                        <div className="col-12">
                            <label htmlFor="reproMotivo">Motivo <span style={{ color: '#DC2626' }}>*</span></label>
                            <InputText id="reproMotivo" value={reproMotivo} onChange={(e) => setReproMotivo(e.target.value)}
                                placeholder="Obligatorio: queda en el log" />
                        </div>
                    </div>
                )}
            </Dialog>

            {/* ---- Ayuda: de dónde sale cada fecha del ciclo ----
                 El orden de las tarjetas es el orden real de los hechos, para que se
                 lea como la historia del contenedor y no como una lista de campos. */}
            <Dialog header="¿Cómo se calculan las fechas?" visible={ayudaVisible} style={{ width: '820px' }} modal
                onHide={() => setAyudaVisible(false)}>
                <p style={{ marginTop: 0, color: '#4B5563' }}>
                    El ciclo de un contenedor en orden. Cada fecha la dispara un hecho distinto:
                    unas vienen del GPS del candado, otras de lo que alguien carga a mano, y otras
                    se calculan sumando un tiempo configurado.
                </p>

                <h4 style={{ marginBottom: '.4rem' }}>1 · El vacío va del patio a la finca</h4>
                <ul style={{ marginTop: 0, lineHeight: 1.7 }}>
                    <li><b>Inicio del vacío</b> — cuando se asigna el candado en el patio y se sella el contenedor.</li>
                    <li><b>Fin del vacío</b> — cuando el candado entra al radio configurado de la finca. Ese mismo
                        instante <b>crea el viaje lleno</b>, que nace en Standby / No Despachado.</li>
                </ul>

                <h4 style={{ marginBottom: '.4rem' }}>2 · La carga en la finca</h4>
                <ul style={{ marginTop: 0, lineHeight: 1.7 }}>
                    <li><b>Candado Apertura Carga</b> — la primera vez que el candado se abre después de llegar.
                        Es el arranque de la carga.</li>
                    <li><b>Candado Cierre Carga</b> — la primera vez que vuelve a cerrarse después de esa apertura.
                        Es el fin de la carga. Se busca <b>sólo entre la llegada a la finca y la salida</b>: por eso ya
                        no puede confundirse con el sellado del vacío en el patio, que es de antes.</li>
                </ul>

                <h4 style={{ marginBottom: '.4rem' }}>3 · El lleno viaja a R10</h4>
                <ul style={{ marginTop: 0, lineHeight: 1.7 }}>
                    <li><b>F. Inicio</b> (del lleno) — cuando ya cargó y arrancó. Requiere <b>las dos cosas</b>: que el
                        candado se haya cerrado en la finca, y que después el camión se aleje del radio configurado
                        <b> con velocidad</b>. Si el candado no cierra en el plazo configurado, sale igual con el
                        criterio de distancia, y queda anotado en <b>Motivo Inicio</b>. Es la base del ETA R10.</li>
                    <li><b>ETA R10</b> — estimado: <i>F. Inicio del lleno + TTT de la finca</i>. El TTT se configura por
                        finca en el maestro de Ubicaciones.</li>
                    <li><b>ATA R10</b> — llegada real, tomada del GPS.</li>
                    <li><b>Candado Apertura R10</b> — cuando se abre el candado ya en R10.</li>
                    <li><b>Horas Candado</b> — las horas entre el cierre en finca y la apertura en R10: el tiempo que
                        el contenedor viajó sellado.</li>
                </ul>

                <h4 style={{ marginBottom: '.4rem' }}>4 · De R10 a BNP</h4>
                <ul style={{ marginTop: 0, lineHeight: 1.7 }}>
                    <li><b>ETA BNP</b> — <i>apertura del candado en R10 + las horas configuradas</i>. Si no hubo apertura
                        en R10, queda pendiente: no se estima sin ese dato.</li>
                    <li><b>ATA BNP</b> — llegada real. Se carga desde el archivo ATA BNP en la pantalla de Booking, o a mano.</li>
                </ul>

                <h4 style={{ marginBottom: '.4rem' }}>Estados</h4>
                <ul style={{ marginTop: 0, lineHeight: 1.7 }}>
                    <li><b>Estado Logístico</b> — No Despachado (todavía en finca), En Ruta (viajando), Posicionado (llegó)
                        o YILPORT (prioridad que no lleva GPS).</li>
                    <li><b>Estado del viaje</b> — Standby, Activo, Atrasado, Finalizado o Anulado. «Atrasado» sale de
                        comparar contra la <b>F. Viaje Esperada</b>.</li>
                    <li><b>Motivo Cierre</b> — por qué cerró: llegada a destino, cierre automático por pérdida de señal,
                        o reproceso manual. Conviene mirarlo antes de sacar conclusiones de una fecha de fin.</li>
                </ul>

                <p style={{ marginBottom: 0, fontSize: '.85rem', color: '#6B7280' }}>
                    Cada columna de fecha tiene además un <i className="pi pi-question-circle" /> al lado del título con
                    su explicación corta. Si una regla cambia, este texto se actualiza junto con el cálculo.
                </p>
            </Dialog>

            {/* ---- Visor del log unificado (RF-LOG) ---- */}
            <Dialog header="Log de cambios" visible={logVisible} style={{ width: '70vw' }} modal
                onHide={() => setLogVisible(false)}>
                <DataTable value={logFilas} size="small" paginator rows={10} emptyMessage="Sin cambios registrados">
                    <Column field="fecha" header="Fecha" style={{ minWidth: '11rem' }} />
                    <Column field="entidad" header="Entidad" style={{ minWidth: '7rem' }} />
                    <Column field="entidadId" header="Id" style={{ minWidth: '5rem' }} />
                    <Column field="campo" header="Campo" style={{ minWidth: '9rem' }} />
                    <Column field="valorAnterior" header="Antes" style={{ minWidth: '9rem' }} />
                    <Column field="valorNuevo" header="Después" style={{ minWidth: '9rem' }} />
                    <Column field="motivo" header="Motivo" style={{ minWidth: '14rem' }} />
                    <Column header="Automático" body={(r) => r.esAutomatico ? 'Sí' : 'No'} style={{ minWidth: '6rem' }} />
                </DataTable>
            </Dialog>

            {/* ---- Detalle del viaje en formulario (mejor lectura) ---- */}
            <Dialog header={detalleViaje ? `Detalle · Viaje ${detalleViaje.viajeId} · Booking ${detalleViaje.bookingCodigo}` : 'Detalle del viaje'}
                visible={detalleVisible} style={{ width: '780px' }} modal onHide={() => setDetalleVisible(false)}
                footer={detalleViaje && detalleViaje.viajeId ? (
                    esAnden ? (
                        // Rol DOLE-ANDEN: solo lectura -> unicamente ver log, sin mutaciones.
                        <div className="flex flex-wrap gap-2 justify-content-end">
                            <Button label="Log" icon="pi pi-history" className="p-button-sm p-button-secondary"
                                onClick={() => verLog(detalleViaje)} />
                        </div>
                    ) : (
                    <div className="flex flex-wrap gap-2 justify-content-end">
                        {detalleViaje.estado === 'Anulado'
                            ? <Button label="Reactivar" icon="pi pi-replay" className="p-button-sm p-button-success"
                                onClick={() => abrirAccion('reactivar', detalleViaje)} />
                            : <Button label="Anular" icon="pi pi-times" className="p-button-sm p-button-danger"
                                onClick={() => abrirAccion('anular', detalleViaje)} />}
                        <Button label="Cambiar destino" icon="pi pi-directions" className="p-button-sm p-button-help"
                            onClick={() => abrirAccion('destino', detalleViaje)} />
                        <Button label="ATA BNP" icon="pi pi-calendar-plus" className="p-button-sm p-button-info"
                            onClick={() => abrirAccion('atabnp', detalleViaje)} />
                        <Button label="Log" icon="pi pi-history" className="p-button-sm p-button-secondary"
                            onClick={() => verLog(detalleViaje)} />
                    </div>
                    )
                ) : null}>
                {detalleViaje && (() => {
                    const d = detalleViaje;
                    const tipo = d.tipoViaje && d.tipoViaje.nombre ? d.tipoViaje.nombre : d.tipoViaje;
                    // Formatea fechas de etapa a DD-MM-YYYY HH:MM:SS. Deja intactos los strings ya formateados.
                    const fFecha = (v) => {
                        if (!v) return null;
                        if (typeof v === 'string' && /^\d{2}-\d{2}-\d{4}/.test(v)) return v;
                        const dt = new Date(v);
                        if (isNaN(dt.getTime())) return (typeof v === 'string' ? v : null);
                        const p = (n) => String(n).padStart(2, '0');
                        return `${p(dt.getDate())}-${p(dt.getMonth() + 1)}-${dt.getFullYear()} ${p(dt.getHours())}:${p(dt.getMinutes())}:${p(dt.getSeconds())}`;
                    };
                    // Estados normalizados (vienen sin espacios) -> texto legible.
                    const estLog = { 'Posicionado': 'Posicionado', 'EnRuta': 'En Ruta', 'NoDespachado': 'No Despachado' }[d.estadoLogistico] || d.estadoLogistico;
                    const estPos = { 'ATiempo': 'A Tiempo', 'Atrasado': 'Atrasado' }[d.estadoPosicionamiento] || d.estadoPosicionamiento;
                    const campos = [
                        // Identificacion y estados
                        ['Booking', d.bookingCodigo], ['Contenedor', d.contenedor], ['Tipo viaje', tipo],
                        ['Estado', d.estado], ['Estado Logístico', estLog], ['Estado de Posicionamiento / Retiro', estPos],
                        // Asignacion
                        ['Chofer', d.chofer], ['Vehículo (placa)', d.vehiculoPlaca], ['Chasis', d.vehiculoChasis],
                        ['Empresa', d.empresaTransporte],
                        ['Dispositivo', d.dispositivoNombre], ['ID Dispositivo', d.dispositivoIdentificador],
                        // Origen / destino
                        ['Finca', d.bookingFincaCodigo], ['Ruta', d.ruta], ['Destino', d.destinoNombre],
                        ['Zona de Producción', d.destinoZona], ['Sector', d.destinoSector], ['Cod. Planta Empacadora', d.destinoCodigoPlantaEmpacadora],
                        ['TTT (horas)', d.tttHoras != null ? d.tttHoras + ' h' : null],
                        ['Distancia (km)', d.distanciaKm != null ? d.distanciaKm + ' km' : null],
                        // Comercial
                        ['Categoría', d.categoriaContenedor], ['Barco-Viaje', d.barcoViaje], ['Barco', d.barcoNombre], ['Prioridad Vacío', d.prioridadVacio],
                        // Fechas del viaje
                        ['F. Planificación', fFecha(d.fechaPlanificacion)], ['F. Inicio', fFecha(d.fechaViajeInicio)], ['F. Fin', fFecha(d.fechaViajeFin)],
                        ['F. Esperada', fFecha(d.fechaViajeFinEsperada)], ['T.Viaje (horas)', d.tiempoViajeHoras], ['T.V.Faltante (min)', d.tiempoViajeFaltante],
                        ['F. Esperada Google', fFecha(d.fechaViajeFinEsperadaGoogle)], ['T.V.Faltante Google (min)', d.tiempoViajeFaltanteGoogle],
                        ['Dist. Faltante (km)', d.distanciaViajeFaltante], ['Dist. Faltante Google (km)', d.distanciaViajeFaltanteGoogle],
                        // Etapas DOLE en orden cronologico (patio seco -> carga -> R10 -> BNP)
                        ['Llegada Patio Seco', fFecha(d.llegadaPatioSeco)], ['Salida Patio Seco', fFecha(d.salidaPatioSeco)],
                        ['Candado Apertura Carga', fFecha(d.candadoAperturaCarga)], ['Candado Cierre Carga', fFecha(d.candadoCierreCarga)],
                        ['ETA R10', fFecha(d.etaR10)], ['ATA R10', fFecha(d.ataR10)], ['Candado Apertura R10', fFecha(d.candadoAperturaR10)],
                        ['Horas Candado (Cierre → R10)', d.horasCandado != null ? `${d.horasCandado} h` : ''],
                        ['ETA BNP', fFecha(d.etaBnp)], ['ATA BNP', fFecha(d.ataBnp)],
                        // DOLE tramos a puerto (después de R10)
                        ['Puerto Carga', d.puertoCarga], ['Tipo Chasis', d.tipoChasis], ['TK', d.tk], ['Traslado Directo', d.trasladoDirecto],
                        ['Estado Tramo Puerto', d.estadoPuerto], ['Alertas Tramo Puerto', d.alertasPuerto],
                        ['F1 Candado Chasis R10', fFecha(d.candadoChasisR10)], ['F2 Salida R10', fFecha(d.salidaR10)],
                        ['F3 ATA Puerto', fFecha(d.ataPuerto)], ['F4 Salida Puerto', fFecha(d.salidaPuerto)],
                        ['F5 ATA Retorno', fFecha(d.ataRetorno)], ['F6 Retiro Candado', fFecha(d.retiroCandado)],
                        // GPS / cierre / carga booking
                        ['Punto Cercano', d.puntoCercano], ['F. GPS', fFecha(d.fechaDispositivo)],
                        ['Motivo Inicio', d.motivoInicio], ['Motivo Cierre', d.motivoCierre],
                        ['Acercamiento máx. (m)', d.acercamientoMinM != null ? d.acercamientoMinM + ' m' : null],
                        // Registro en bitacora (despacho del guardia) y carga del booking
                        ['F. Registro Bitácora', fFecha(d.bitacoraFechaIngreso)], ['F. Turno Bitácora', fFecha(d.bitacoraFechaTurno)],
                        ['F. Carga Booking', fFecha(d.bookingFechaCarga)], ['Usuario Carga', d.bookingUsuarioCarga],
                    ];
                    return (
                        <div className="grid">
                            {campos.map(([label, val], i) => (
                                <div key={i} className="col-6 md:col-4" style={{ padding: '6px 10px' }}>
                                    <div style={{ fontSize: '0.72rem', color: '#6B7280' }}>{label}</div>
                                    <div style={{ fontWeight: 600 }}>{val === null || val === undefined || val === '' ? '—' : String(val)}</div>
                                </div>
                            ))}
                        </div>
                    );
                })()}
            </Dialog>

            <Dialog header="Posición Actual" visible={displayMapa} style={{ width: '80vw' }} onHide={() => {
                setOptions("");
                setLatitud("");
                setLongitud("");
                setDisplayMapa(false);

            }}>

                <div className="card">
                    <GMap
                        overlays={overlays}
                        options={options}
                        style={{ width: "100%", minHeight: "320px" }}
                    />
                </div>
            </Dialog>

            <Dialog header="Recorrido del viaje" visible={displayRecorrido} style={{ width: '85vw' }}
                onHide={() => { setDisplayRecorrido(false); setRecorridoOverlays(null); setRecorridoInfo(null); setRecorridoDatos(null); recorridoBoundsRef.current = []; }}>
                {recorridoInfo && (
                    <div className="mb-2" style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', alignItems: 'center' }}>
                        <span><b>Booking:</b> {recorridoInfo.booking}</span>
                        <span><b>Destino:</b> {recorridoInfo.destinoNombre}</span>
                        <span><b>Posiciones:</b> {recorridoInfo.totalPuntos}</span>
                        {recorridoInfo.minDist != null &&
                            <span><b>Acercamiento máx.:</b> {recorridoInfo.minDist} m (radio {recorridoInfo.radio} m)</span>}
                        {recorridoInfo.llego === true &&
                            <span className="p-badge p-badge-success">Sí entró al destino</span>}
                        {recorridoInfo.llego === false &&
                            <span className="p-badge p-badge-danger">Nunca entró al destino</span>}
                        {recorridoInfo.estado &&
                            <span><b>Estado:</b> {recorridoInfo.estado}</span>}
                        {recorridoInfo.motivoCierre &&
                            <span className="p-badge p-badge-info" style={{ whiteSpace: 'normal' }}>Cierre: {recorridoInfo.motivoCierre}</span>}
                    </div>
                )}
                {recorridoInfo && (recorridoInfo.tramosPuerto || []).length > 0 && (
                    <div className="mb-2" style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                        {/* Con dos candados (traslado directo: el del contenedor hace el viaje, el del chasis sigue
                            después) se elige cuál ver: el recorrido y sus alertas cambian. */}
                        {recorridoInfo.tramosPuerto.some(t => t.tipoCandado === 'CHASIS') && (
                            <SelectButton value={recorridoCandado} onChange={(e) => elegirCandadoRecorrido(e.value)}
                                options={[{ label: 'Ambos candados', value: 'TODOS' },
                                    { label: 'Candado 1 · contenedor', value: 'CONTENEDOR' },
                                    { label: 'Candado 2 · chasis', value: 'CHASIS' }]} />
                        )}
                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'center', fontSize: '0.85rem' }}>
                            <span><span style={{ display: 'inline-block', width: 22, height: 4, background: COLOR_LLENO, verticalAlign: 'middle' }} /> Viaje hasta F1 (cierre en R10)</span>
                            {['RUTA PUERTO', 'EN PUERTO', 'RUTA DEPOT'].map(e => (
                                <span key={e}><span style={{ display: 'inline-block', width: 22, height: 4, background: COLOR_ETAPA[e], verticalAlign: 'middle' }} /> {e}</span>
                            ))}
                            <span>Punteado = candado del chasis</span>
                            <span><b style={{ color: '#B91C1C' }}>!</b> = alerta</span>
                        </div>
                        {recorridoInfo.tramosPuerto
                            .filter(t => recorridoCandado === 'TODOS' || t.tipoCandado === recorridoCandado)
                            .map(t => (
                                <div key={t.tipoCandado + t.candado} style={{ fontSize: '0.85rem' }}>
                                    <b>Después de R10 ({nombreCandado(t.tipoCandado)} {t.candado}):</b> {t.estado} · {t.puntos} posiciones
                                    {t.fechas.length > 0 && <span> · {t.fechas.map(h => h.tipo + ' ' + h.fecha).join(' · ')}</span>}
                                    {t.alertas.map((h, i) => (
                                        <div key={i} style={{ color: '#B91C1C', fontWeight: 600 }}>
                                            {h.tipo} · {h.fecha}{h.detalle ? ' · ' + h.detalle : ''}
                                        </div>
                                    ))}
                                </div>
                            ))}
                    </div>
                )}
                <div className="card">
                    <GMap
                        overlays={recorridoOverlays}
                        options={recorridoOptions}
                        onMapReady={onRecorridoMapReady}
                        style={{ width: "100%", minHeight: "60vh" }}
                    />
                </div>
            </Dialog>


        </>
    )
}

export default Logistica
